'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var merge = _interopDefault(require('lodash/merge'));
var styled = _interopDefault(require('react-emotion'));
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Isvg = _interopDefault(require('react-inlinesvg'));
var moment = _interopDefault(require('moment'));
var emotion = require('emotion');
require('react-dates/initialize');
var DateRangePicker = _interopDefault(require('react-dates/lib/components/DateRangePicker'));
var constants = require('react-dates/constants');
var emotionTheming = require('emotion-theming');
var orderBy = _interopDefault(require('lodash/orderBy'));
var get = _interopDefault(require('lodash/get'));
var isEqual = _interopDefault(require('lodash/isEqual'));
var uniqueId = _interopDefault(require('lodash/uniqueId'));

var palette = {
  primary: {
    light: '#6c7378',
    main: '#415667',
    dark: '#4e5c67',
    text: '#fff'
  },
  secondary: {
    light: '#1981c4',
    main: '#1576b4',
    dark: '#2f659c',
    text: '#fff'
  },
  error: {
    light: '#bf2c30',
    main: '#b01e22',
    dark: '#6f1315',
    text: '#fff'
  },
  warning: {
    light: '#ffcc00',
    main: '#ff9966',
    dark: '#da6b46',
    text: '#fff'
  },
  success: {
    light: '#81c784',
    main: '#4caf50',
    dark: '#2e7d32',
    text: '#fff'
  }
};

var colours = {
  grey: {
    100: '#e7e9ea',
    200: '#e1e1e1',
    300: '#d6d6d6',
    400: '#cfd2d4',
    500: '#999b9d',
    600: '#808080',
    700: '#777',
    800: '#595959',
    900: '#484848',
    1000: '#757575'
  },
  blue: {
    100: '#7ca2bb',
    200: '#c3d5e1'
  }
};

var shadows = {
  black: {
    100: 'rgba(0, 0, 0, 0.07)',
    200: 'rgba(0, 0, 0, 0.2)',
    300: 'rgba(0, 0, 0, 0.33)',
    400: 'rgba(0, 0, 0, 0.4)',
    500: 'rgba(0, 0, 0, 0.5)',
    600: 'rgba(0, 0, 0, 0.6)',
    700: 'rgba(0, 0, 0, 0.7)',
    800: 'rgba(0, 0, 0, 0.8)',
    900: 'rgba(0, 0, 0, 0.9)'
  },
  grey: {
    100: 'rgba(72, 72, 72, 0.07)',
    200: 'rgba(72, 72, 72, 0.2)',
    300: 'rgba(72, 72, 72, 0.33)',
    400: 'rgba(72, 72, 72, 0.4)',
    500: 'rgba(72, 72, 72, 0.5)',
    600: 'rgba(72, 72, 72, 0.6)',
    700: 'rgba(72, 72, 72, 0.7)',
    800: 'rgba(72, 72, 72, 0.8)',
    900: 'rgba(72, 72, 72, 0.9)'
  }
};

var layout = {
  borderRadius: '5px',
  spacing: 8
};

var typography = {
  family: 'poppins, Arial, sans-serif',
  size: '14px',
  lineHeight: '18px',
  weightLight: 400,
  weightNormal: 500,
  weightBold: 600,
  colour: palette.primary.dark
};

typography.title = {
  size: '30px',
  weight: typography.weightBold,
  colour: typography.colour
};

typography.subtitle = {
  size: '16px',
  weight: typography.weightNormal,
  colour: palette.primary.main
};

typography.heading = {
  size: '25px',
  weight: typography.weightBold
};

typography.modalTitle = {
  size: '20px',
  weight: typography.weightNormal
};

typography.info = {
  size: '13px',
  weight: typography.weightNormal
};

var zIndex = {
  dropdown: 90,
  modal: 100
};

/*
 * Override styles for specific components
 * Look at the Theming confluence doc for info on all available overrides:
 * https://mathletics.atlassian.net/wiki/spaces/BFT/pages/642515121/Theming
 * Alternatively, look in each component's styled.js file or 'theme overrides' story
 *
 */

var overrides = {
  button: {},
  calendar: {},
  container: {},
  dataTable: {},
  dropdownMenu: {},
  header: {},
  footer: {},
  modal: {},
  radio: {},
  search: {}
};

var defaultTheme = {
  palette: palette,
  colours: colours,
  shadows: shadows,
  layout: layout,
  typography: typography,
  zIndex: zIndex,
  overrides: overrides
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var ThemeHelper = function () {
  function ThemeHelper() {
    classCallCheck(this, ThemeHelper);
  }

  createClass(ThemeHelper, null, [{
    key: 'getTheme',

    /**
     * If props contains no theme object or the theme object is empty, returns the base theme
     * Otherwise recursively merges props.theme on top of base theme
     */
    value: function getTheme(props) {
      if (props.theme && Object.keys(props.theme).length > 0) {
        return merge({}, defaultTheme, props.theme);
      }
      return defaultTheme;
    }
  }, {
    key: 'getDefaultTheme',
    value: function getDefaultTheme() {
      return defaultTheme;
    }

    /* Calculate any theme overrides of the default values for this component */

  }, {
    key: 'getComponentOverrides',
    value: function getComponentOverrides(theme, component, defaultValues) {
      return merge({}, defaultValues(theme), theme.overrides[component]);
    }
  }]);
  return ThemeHelper;
}();

var ICON_AND_TEXT = 'ICON_AND_TEXT';
var TEXT_ONLY = 'TEXT_ONLY';
var ICON_ONLY = 'ICON_ONLY';

var SQUARE = 'SQUARE';
var LOZENGE = 'LOZENGE';

var SMALL = 'SMALL';
var MEDIUM = 'MEDIUM';
var LARGE = 'LARGE';

var LEFT = 'LEFT';
var RIGHT = 'RIGHT';

var defaultValues = function defaultValues(theme) {
  var typography = theme.typography,
      layout = theme.layout;

  return {
    size: {
      small: {
        icon: 12,
        deltaX: 1,
        deltaY: 0.75
      },
      medium: {
        icon: 20,
        deltaX: 2,
        deltaY: 1
      },
      large: {
        icon: 28,
        deltaX: 2.75,
        deltaY: 1.5
      }
    },
    fontSize: typography.size,
    lineHeight: typography.lineHeight,
    borderRadius: layout.borderRadius,
    spacing: layout.spacing,
    boxShadow: 'none',
    minWidth: 'auto' // applies to buttons with text only
  };
};

function getOverrides(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'button', defaultValues);
}

var getColours = function getColours(props, palette, typography, inverse) {
  var bgColour = '#fff';
  var borderColour = '#fff';
  var textColour = typography.colour;

  if (props.primary) {
    bgColour = palette.primary.main;
    borderColour = palette.primary.dark;
    textColour = palette.primary.text;
  } else if (props.danger) {
    bgColour = palette.error.light;
    borderColour = palette.error.main;
    textColour = palette.error.text;
  } else if (props.info) {
    bgColour = palette.secondary.light;
    borderColour = palette.secondary.main;
    textColour = palette.secondary.text;
  }

  if (inverse) {
    return {
      bgColour: textColour,
      borderColour: textColour,
      textColour: borderColour
    };
  }
  return { bgColour: bgColour, borderColour: borderColour, textColour: textColour };
};

var getSize = function getSize(buttonSize, theme) {
  var _getOverrides = getOverrides(theme),
      size = _getOverrides.size;

  if (buttonSize === SMALL) {
    return size.small.icon + 'px';
  } else if (buttonSize === LARGE) {
    return size.large.icon + 'px';
  }
  return size.medium.icon + 'px';
};

var getPadding = function getPadding(buttonSize, buttonState, theme) {
  var _getOverrides2 = getOverrides(theme),
      size = _getOverrides2.size,
      spacing = _getOverrides2.spacing;

  var _size$medium = size.medium,
      deltaX = _size$medium.deltaX,
      deltaY = _size$medium.deltaY;

  if (buttonSize === SMALL) {
    var _size$small = size.small;
    deltaX = _size$small.deltaX;
    deltaY = _size$small.deltaY;
  } else if (buttonSize === LARGE) {
    var _size$large = size.large;
    deltaX = _size$large.deltaX;
    deltaY = _size$large.deltaY;
  }

  var padding = spacing * deltaY + 'px ' + spacing * deltaX + 'px';
  if (buttonState === ICON_ONLY) {
    padding = 0;
  } else if (buttonState === ICON_AND_TEXT) {
    padding = spacing * deltaY * 0.5 + 'px ' + spacing * deltaX + 'px';
  }

  return padding;
};

var getIconPadding = function getIconPadding(buttonSize, buttonState, alignIcon) {
  var delta = 1;
  if (buttonSize === SMALL) {
    delta = 0.75;
  } else if (buttonSize === LARGE) {
    delta = 1.5;
  }

  if (buttonState === ICON_ONLY) {
    return 4 * delta + 'px';
  }
  if (alignIcon === RIGHT) {
    return 4 * delta + 'px 0 ' + 4 * delta + 'px ' + 8 * delta + 'px';
  }
  return 4 * delta + 'px ' + 8 * delta + 'px ' + 4 * delta + 'px 0';
};

var getTextStyles = function getTextStyles(buttonSize, theme) {
  var _getOverrides3 = getOverrides(theme),
      fontSize = _getOverrides3.fontSize,
      lineHeight = _getOverrides3.lineHeight;

  if (buttonSize === SMALL) {
    fontSize = parseInt(fontSize, 10) - 2 + 'px';
    lineHeight = parseInt(fontSize, 10) - 2 + 'px';
  } else if (buttonSize === LARGE) {
    fontSize = parseInt(fontSize, 10) + 2 + 'px';
    lineHeight = parseInt(fontSize, 10) + 2 + 'px';
  }

  return { fontSize: fontSize, lineHeight: lineHeight };
};

var getMinWidth = function getMinWidth(buttonSize, baseMinWidth) {
  var minWidth = parseInt(baseMinWidth, 10);
  if (Number.isNaN(minWidth)) {
    return baseMinWidth;
  }

  if (buttonSize === SMALL) {
    minWidth *= 0.5;
  } else if (buttonSize === LARGE) {
    minWidth *= 1.25;
  }
  return minWidth + 'px';
};

var ButtonWrapper = /*#__PURE__*/styled('div', {
  target: 'evonh4d0',
  label: 'ButtonWrapper'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);
  var palette = theme.palette,
      typography = theme.typography;

  var _getOverrides4 = getOverrides(theme),
      borderRadius = _getOverrides4.borderRadius,
      boxShadow = _getOverrides4.boxShadow,
      minWidth = _getOverrides4.minWidth;

  var buttonState = props.buttonState,
      size = props.size;

  var _getColours = getColours(props, palette, typography, props.inverse),
      bgColour = _getColours.bgColour,
      borderColour = _getColours.borderColour,
      textColour = _getColours.textColour;

  var padding = getPadding(size, buttonState, theme);

  var _getTextStyles = getTextStyles(size, theme),
      fontSize = _getTextStyles.fontSize,
      lineHeight = _getTextStyles.lineHeight;

  var btnBorderRadius = props.type === LOZENGE ? getSize(props.size, theme) : borderRadius;
  var btnMinWidth = props.buttonState !== ICON_ONLY ? 'min-width: ' + getMinWidth(size, minWidth) + ';' : '';

  return '\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-family: ' + typography.family + ';\n    font-size: ' + fontSize + ';\n    line-height: ' + lineHeight + ';\n    text-align: center;\n    border-radius: ' + btnBorderRadius + ';\n    background-color: ' + bgColour + ';\n    border: 2px solid ' + borderColour + ';\n    box-sizing: border-box;\n    color: ' + textColour + ';\n    padding: ' + padding + ';\n    box-shadow: ' + boxShadow + ';\n    transition: filter 0.2s;\n    ' + btnMinWidth + '\n\n    &:hover {\n      filter: brightness(1.1);\n    }\n\n    ' + (props.disabled && '\n    cursor: not-allowed;\n    box-shadow: none;\n    opacity: 0.65;\n\n    &:focus {\n        outline: 0;\n    }\n\n    &:hover {\n      filter: none;\n    }\n    ') + '\n  ';
});

var Icon = /*#__PURE__*/styled('div', {
  target: 'evonh4d1',
  label: 'Icon'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);
  var size = props.size,
      buttonState = props.buttonState,
      alignIcon = props.alignIcon;

  var iconSize = getSize(size, theme);
  return '\n    display: flex;\n    align-items: center;\n    height: ' + iconSize + ';\n    width: ' + iconSize + ';\n    padding: ' + getIconPadding(size, buttonState, alignIcon) + ';\n\n    svg {\n      height: 100%;\n      width: 100%;\n\n      path {\n          fill: currentColor !important;\n      }\n    }\n  ';
});

/**
 * Button component
 * Supports different styles through setting primary, danger & info props
 */
var Button = function Button(props) {
  var text = props.text,
      icon = props.icon,
      _onClick = props.onClick,
      disabled = props.disabled,
      className = props.className,
      type = props.type,
      size = props.size,
      alignIcon = props.alignIcon;


  var styleProps = {};
  ['primary', 'danger', 'info', 'disabled', 'inverse'].forEach(function (style) {
    if (props[style]) {
      styleProps[style] = true;
    }
  });

  var buttonState = TEXT_ONLY;
  if (icon && text) {
    buttonState = ICON_AND_TEXT;
  } else if (icon) {
    buttonState = ICON_ONLY;
  }

  function renderIcon() {
    return React__default.createElement(
      Icon,
      { buttonState: buttonState, size: size, alignIcon: alignIcon, key: 1 },
      React__default.createElement(Isvg, { src: icon, cacheRequests: true })
    );
  }

  function getContent() {
    if (!icon) {
      return text;
    }
    if (alignIcon === RIGHT) {
      return [text, renderIcon()];
    }
    return [renderIcon(), text];
  }

  return React__default.createElement(
    ButtonWrapper,
    _extends({}, styleProps, {
      buttonState: buttonState,
      type: type,
      size: size,
      className: className,
      role: 'button',
      tabIndex: '0',
      onClick: function onClick() {
        if (!disabled) {
          _onClick();
        }
      }
    }),
    getContent()
  );
};

Button.SQUARE = SQUARE;
Button.LOZENGE = LOZENGE;
Button.SMALL = SMALL;
Button.MEDIUM = MEDIUM;
Button.LARGE = LARGE;
Button.LEFT = LEFT;
Button.RIGHT = RIGHT;

Button.propTypes = {
  /** Text to display inside of button (can be combined with icon) */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** SVG icon to display inside of button (can be combined with text) */
  icon: PropTypes.string,
  /** If use both icon and text aligns icon to side of text */
  alignIcon: PropTypes.oneOf([Button.LEFT, Button.RIGHT]),
  /** Callback when button is clicked */
  onClick: PropTypes.func.isRequired,
  /** Use primary styles */
  primary: PropTypes.bool,
  /** Use danger styles */
  danger: PropTypes.bool,
  /** Use info styles */
  info: PropTypes.bool,
  /** Flip background and font colours */
  inverse: PropTypes.bool,
  /** Button cannot be clicked, and displays with an alpha and a not-allowed cursor */
  disabled: PropTypes.bool,
  /** Type of button this is, quick way to apply styles */
  type: PropTypes.oneOf([Button.SQUARE, Button.LOZENGE]),
  /** Size of button */
  size: PropTypes.oneOf([Button.SMALL, Button.MEDIUM, Button.LARGE]),
  /** Custom class to attach to parent div - use this to override any styles */
  className: PropTypes.string
};

Button.defaultProps = {
  type: Button.SQUARE,
  size: Button.MEDIUM,
  alignIcon: Button.LEFT,
  primary: false,
  danger: false,
  info: false,
  disabled: false,
  inverse: false
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".PresetDateRangePicker_panel {\n  padding: 0 22px 11px\n}\n.PresetDateRangePicker_button {\n  position: relative;\n  height: 100%;\n  text-align: center;\n  background: 0 0;\n  border: 2px solid #00a699;\n  color: #00a699;\n  padding: 4px 12px;\n  margin-right: 8px;\n  font: inherit;\n  font-weight: 700;\n  line-height: normal;\n  overflow: visible;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer\n}\n.PresetDateRangePicker_button:active {\n  outline: 0\n}\n.PresetDateRangePicker_button__selected {\n  color: #fff;\n  background: #00a699\n}\n.SingleDatePickerInput {\n  display: inline-block;\n  background-color: #fff\n}\n.SingleDatePickerInput__withBorder {\n  border: 1px solid #dbdbdb\n}\n.SingleDatePickerInput__rtl {\n  direction: rtl\n}\n.SingleDatePickerInput__disabled {\n  background-color: #f2f2f2\n}\n.SingleDatePickerInput__block {\n  display: block\n}\n.SingleDatePickerInput__showClearDate {\n  padding-right: 30px\n}\n.SingleDatePickerInput_clearDate {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%)\n}\n.SingleDatePickerInput_clearDate__default:focus,\n.SingleDatePickerInput_clearDate__default:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n.SingleDatePickerInput_clearDate__small {\n  padding: 6px\n}\n.SingleDatePickerInput_clearDate__hide {\n  visibility: hidden\n}\n.SingleDatePickerInput_clearDate_svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n.SingleDatePickerInput_clearDate_svg__small {\n  height: 9px\n}\n.SingleDatePickerInput_calendarIcon {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n.SingleDatePickerInput_calendarIcon_svg {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n.SingleDatePicker {\n  position: relative;\n  display: inline-block\n}\n.SingleDatePicker__block {\n  display: block\n}\n.SingleDatePicker_picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n.SingleDatePicker_picker__rtl {\n  direction: rtl\n}\n.SingleDatePicker_picker__directionLeft {\n  left: 0\n}\n.SingleDatePicker_picker__directionRight {\n  right: 0\n}\n.SingleDatePicker_picker__portal {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n.SingleDatePicker_picker__fullScreenPortal {\n  background-color: #fff\n}\n.SingleDatePicker_closeButton {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n.SingleDatePicker_closeButton:focus,\n.SingleDatePicker_closeButton:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n.SingleDatePicker_closeButton_svg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n.DayPickerKeyboardShortcuts_buttonReset {\n  background: 0 0;\n  border: 0;\n  border-radius: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  font-size: 14px\n}\n.DayPickerKeyboardShortcuts_buttonReset:active {\n  outline: 0\n}\n.DayPickerKeyboardShortcuts_show {\n  width: 22px;\n  position: absolute;\n  z-index: 2\n}\n.DayPickerKeyboardShortcuts_show__bottomRight {\n  border-top: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  bottom: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__bottomRight:hover {\n  border-right: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_show__topRight {\n  border-bottom: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  top: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__topRight:hover {\n  border-right: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_show__topLeft {\n  border-bottom: 26px solid transparent;\n  border-left: 33px solid #00a699;\n  top: 0;\n  left: 0\n}\n.DayPickerKeyboardShortcuts_show__topLeft:hover {\n  border-left: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_showSpan {\n  color: #fff;\n  position: absolute\n}\n.DayPickerKeyboardShortcuts_showSpan__bottomRight {\n  bottom: 0;\n  right: -28px\n}\n.DayPickerKeyboardShortcuts_showSpan__topRight {\n  top: 1px;\n  right: -28px\n}\n.DayPickerKeyboardShortcuts_showSpan__topLeft {\n  top: 1px;\n  left: -28px\n}\n.DayPickerKeyboardShortcuts_panel {\n  overflow: auto;\n  background: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 2px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  padding: 22px;\n  margin: 33px\n}\n.DayPickerKeyboardShortcuts_title {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0\n}\n.DayPickerKeyboardShortcuts_list {\n  list-style: none;\n  padding: 0;\n  font-size: 14px\n}\n.DayPickerKeyboardShortcuts_close {\n  position: absolute;\n  right: 22px;\n  top: 22px;\n  z-index: 2\n}\n.DayPickerKeyboardShortcuts_close:active {\n  outline: 0\n}\n.DayPickerKeyboardShortcuts_closeSvg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n.DayPickerKeyboardShortcuts_closeSvg:focus,\n.DayPickerKeyboardShortcuts_closeSvg:hover {\n  fill: #82888a\n}\n.CalendarDay {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center\n}\n.CalendarDay:active {\n  outline: 0\n}\n.CalendarDay__defaultCursor {\n  cursor: default\n}\n.CalendarDay__default {\n  border: 1px solid #e4e7e7;\n  color: #484848;\n  background: #fff\n}\n.CalendarDay__default:hover {\n  background: #e4e7e7;\n  border: 1px double #e4e7e7;\n  color: inherit\n}\n.CalendarDay__hovered_offset {\n  background: #f4f5f5;\n  border: 1px double #e4e7e7;\n  color: inherit\n}\n.CalendarDay__outside {\n  border: 0;\n  background: #fff;\n  color: #484848\n}\n.CalendarDay__blocked_minimum_nights {\n  background: #fff;\n  border: 1px solid #eceeee;\n  color: #cacccd\n}\n.CalendarDay__blocked_minimum_nights:active,\n.CalendarDay__blocked_minimum_nights:hover {\n  background: #fff;\n  color: #cacccd\n}\n.CalendarDay__highlighted_calendar {\n  background: #ffe8bc;\n  color: #484848\n}\n.CalendarDay__highlighted_calendar:active,\n.CalendarDay__highlighted_calendar:hover {\n  background: #ffce71;\n  color: #484848\n}\n.CalendarDay__selected_span {\n  background: #66e2da;\n  border: 1px solid #33dacd;\n  color: #fff\n}\n.CalendarDay__selected_span:active,\n.CalendarDay__selected_span:hover {\n  background: #33dacd;\n  border: 1px solid #33dacd;\n  color: #fff\n}\n.CalendarDay__last_in_range {\n  border-right: #00a699\n}\n.CalendarDay__selected,\n.CalendarDay__selected:active,\n.CalendarDay__selected:hover {\n  background: #00a699;\n  border: 1px solid #00a699;\n  color: #fff\n}\n.CalendarDay__hovered_span,\n.CalendarDay__hovered_span:hover {\n  background: #b2f1ec;\n  border: 1px solid #80e8e0;\n  color: #007a87\n}\n.CalendarDay__hovered_span:active {\n  background: #80e8e0;\n  border: 1px solid #80e8e0;\n  color: #007a87\n}\n.CalendarDay__blocked_calendar,\n.CalendarDay__blocked_calendar:active,\n.CalendarDay__blocked_calendar:hover {\n  background: #cacccd;\n  border: 1px solid #cacccd;\n  color: #82888a\n}\n.CalendarDay__blocked_out_of_range,\n.CalendarDay__blocked_out_of_range:active,\n.CalendarDay__blocked_out_of_range:hover {\n  background: #fff;\n  border: 1px solid #e4e7e7;\n  color: #cacccd\n}\n.CalendarMonth {\n  background: #fff;\n  text-align: center;\n  padding: 0 13px;\n  vertical-align: top;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n.CalendarMonth_table {\n  border-collapse: collapse;\n  border-spacing: 0\n}\n.CalendarMonth_verticalSpacing {\n  border-collapse: separate\n}\n.CalendarMonth_caption {\n  color: #484848;\n  font-size: 18px;\n  text-align: center;\n  padding-top: 22px;\n  padding-bottom: 37px;\n  caption-side: initial\n}\n.CalendarMonth_caption__verticalScrollable {\n  padding-top: 12px;\n  padding-bottom: 7px\n}\n.CalendarMonthGrid {\n  background: #fff;\n  text-align: left;\n  z-index: 0\n}\n.CalendarMonthGrid__animating {\n  z-index: 1\n}\n.CalendarMonthGrid__horizontal {\n  position: absolute;\n  left: 9px\n}\n.CalendarMonthGrid__vertical {\n  margin: 0 auto\n}\n.CalendarMonthGrid__vertical_scrollable {\n  margin: 0 auto;\n  overflow-y: scroll\n}\n.CalendarMonthGrid_month__horizontal {\n  display: inline-block;\n  vertical-align: top;\n  min-height: 100%\n}\n.CalendarMonthGrid_month__hideForAnimation {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none\n}\n.CalendarMonthGrid_month__hidden {\n  visibility: hidden\n}\n.DayPickerNavigation_container {\n  position: relative;\n  z-index: 2\n}\n.DayPickerNavigation_container__vertical {\n  background: #fff;\n  box-shadow: 0 0 5px 2px rgba(0,0,0,.1);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 52px;\n  width: 100%\n}\n.DayPickerNavigation_container__verticalScrollable {\n  position: relative\n}\n.DayPickerNavigation_button {\n  cursor: pointer;\n  line-height: .78;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n.DayPickerNavigation_button__default {\n  border: 1px solid #e4e7e7;\n  background-color: #fff;\n  color: #757575\n}\n.DayPickerNavigation_button__default:focus,\n.DayPickerNavigation_button__default:hover {\n  border: 1px solid #c4c4c4\n}\n.DayPickerNavigation_button__default:active {\n  background: #f2f2f2\n}\n.DayPickerNavigation_button__horizontal {\n  border-radius: 3px;\n  padding: 6px 9px;\n  top: 18px;\n  position: absolute\n}\n.DayPickerNavigation_leftButton__horizontal {\n  left: 22px\n}\n.DayPickerNavigation_rightButton__horizontal {\n  right: 22px\n}\n.DayPickerNavigation_button__vertical {\n  display: inline-block;\n  position: relative;\n  height: 100%;\n  width: 50%\n}\n.DayPickerNavigation_button__vertical__default {\n  padding: 5px\n}\n.DayPickerNavigation_nextButton__vertical__default {\n  border-left: 0\n}\n.DayPickerNavigation_nextButton__verticalScrollable {\n  width: 100%\n}\n.DayPickerNavigation_svg__horizontal {\n  height: 19px;\n  width: 19px;\n  fill: #82888a\n}\n.DayPickerNavigation_svg__vertical {\n  height: 42px;\n  width: 42px;\n  fill: #484848\n}\n.DayPicker {\n  background: #fff;\n  position: relative;\n  text-align: left\n}\n.DayPicker__horizontal {\n  background: #fff\n}\n.DayPicker__verticalScrollable {\n  height: 100%\n}\n.DayPicker__hidden {\n  visibility: hidden\n}\n.DayPicker__withBorder {\n  box-shadow: 0 2px 6px rgba(0,0,0,.05),0 0 0 1px rgba(0,0,0,.07);\n  border-radius: 3px\n}\n.DayPicker_portal__horizontal {\n  box-shadow: none;\n  position: absolute;\n  left: 50%;\n  top: 50%\n}\n.DayPicker_portal__vertical {\n  position: initial\n}\n.DayPicker_focusRegion {\n  outline: 0\n}\n.DayPicker_calendarInfo__horizontal,\n.DayPicker_wrapper__horizontal {\n  display: inline-block;\n  vertical-align: top\n}\n.DayPicker_weekHeaders {\n  position: relative\n}\n.DayPicker_weekHeaders__horizontal {\n  margin-left: 9px\n}\n.DayPicker_weekHeader {\n  color: #757575;\n  position: absolute;\n  top: 62px;\n  z-index: 2;\n  padding: 0 13px;\n  text-align: left\n}\n.DayPicker_weekHeader__vertical {\n  left: 50%\n}\n.DayPicker_weekHeader__verticalScrollable {\n  top: 0;\n  display: table-row;\n  border-bottom: 1px solid #dbdbdb;\n  background: #fff;\n  margin-left: 0;\n  left: 0;\n  width: 100%;\n  text-align: center\n}\n.DayPicker_weekHeader_ul {\n  list-style: none;\n  margin: 1px 0;\n  padding-left: 0;\n  padding-right: 0;\n  font-size: 14px\n}\n.DayPicker_weekHeader_li {\n  display: inline-block;\n  text-align: center\n}\n.DayPicker_transitionContainer {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px\n}\n.DayPicker_transitionContainer__horizontal {\n  -webkit-transition: height .2s ease-in-out;\n  -moz-transition: height .2s ease-in-out;\n  transition: height .2s ease-in-out\n}\n.DayPicker_transitionContainer__vertical {\n  width: 100%\n}\n.DayPicker_transitionContainer__verticalScrollable {\n  padding-top: 20px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  overflow-y: scroll\n}\n.DateInput {\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  position: relative;\n  display: inline-block;\n  width: 130px;\n  vertical-align: middle\n}\n.DateInput__small {\n  width: 97px\n}\n.DateInput__block {\n  width: 100%\n}\n.DateInput__disabled {\n  background: #f2f2f2;\n  color: #dbdbdb\n}\n.DateInput_input {\n  font-weight: 200;\n  font-size: 19px;\n  line-height: 24px;\n  color: #484848;\n  background-color: #fff;\n  width: 100%;\n  padding: 11px 11px 9px;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid transparent;\n  border-left: 0;\n  border-radius: 0\n}\n.DateInput_input__small {\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: .2px;\n  padding: 7px 7px 5px\n}\n.DateInput_input__regular {\n  font-weight: auto\n}\n.DateInput_input__readOnly {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n.DateInput_input__focused {\n  outline: 0;\n  background: #fff;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid #008489;\n  border-left: 0\n}\n.DateInput_input__disabled {\n  background: #f2f2f2;\n  font-style: italic\n}\n.DateInput_screenReaderMessage {\n  border: 0;\n  clip: rect(0,0,0,0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px\n}\n.DateInput_fang {\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  left: 22px;\n  z-index: 2\n}\n.DateInput_fangShape {\n  fill: #fff\n}\n.DateInput_fangStroke {\n  stroke: #dbdbdb;\n  fill: transparent\n}\n.DateRangePickerInput {\n  background-color: #fff;\n  display: inline-block\n}\n.DateRangePickerInput__disabled {\n  background: #f2f2f2\n}\n.DateRangePickerInput__withBorder {\n  border: 1px solid #dbdbdb;\n  border-radius: 2px\n}\n.DateRangePickerInput__rtl {\n  direction: rtl\n}\n.DateRangePickerInput__block {\n  display: block\n}\n.DateRangePickerInput__showClearDates {\n  padding-right: 30px\n}\n.DateRangePickerInput_arrow {\n  display: inline-block;\n  vertical-align: middle;\n  color: #484848\n}\n.DateRangePickerInput_arrow_svg {\n  vertical-align: middle;\n  fill: #484848;\n  height: 24px;\n  width: 24px\n}\n.DateRangePickerInput_clearDates {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%)\n}\n.DateRangePickerInput_clearDates__small {\n  padding: 6px\n}\n.DateRangePickerInput_clearDates_default:focus,\n.DateRangePickerInput_clearDates_default:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n.DateRangePickerInput_clearDates__hide {\n  visibility: hidden\n}\n.DateRangePickerInput_clearDates_svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n.DateRangePickerInput_clearDates_svg__small {\n  height: 9px\n}\n.DateRangePickerInput_calendarIcon {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n.DateRangePickerInput_calendarIcon_svg {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n.DateRangePicker {\n  position: relative;\n  display: inline-block\n}\n.DateRangePicker__block {\n  display: block\n}\n.DateRangePicker_picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n.DateRangePicker_picker__rtl {\n  direction: rtl\n}\n.DateRangePicker_picker__directionLeft {\n  left: 0\n}\n.DateRangePicker_picker__directionRight {\n  right: 0\n}\n.DateRangePicker_picker__portal {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n.DateRangePicker_picker__fullScreenPortal {\n  background-color: #fff\n}\n.DateRangePicker_closeButton {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n.DateRangePicker_closeButton:focus,\n.DateRangePicker_closeButton:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n.DateRangePicker_closeButton_svg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}";
styleInject(css);

var START_DATE = 'startDate';
var END_DATE = 'endDate';

var DateHelper = function () {
  function DateHelper() {
    classCallCheck(this, DateHelper);
  }

  createClass(DateHelper, null, [{
    key: 'getPreviousMonday',
    value: function getPreviousMonday(date) {
      var prevMonday = date ? new Date(date) : new Date();
      prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);
      return prevMonday;
    }
  }, {
    key: 'getThisWeekStartEnd',
    value: function getThisWeekStartEnd() {
      var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

      var thisMonday = DateHelper.getPreviousMonday();
      var startDate = moment(thisMonday).format(formatString);
      var endDate = moment(thisMonday).add(6, 'days').format(formatString);

      return { startDate: startDate, endDate: endDate };
    }
  }, {
    key: 'getLastWeekStartEnd',
    value: function getLastWeekStartEnd() {
      var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

      var thisMonday = DateHelper.getPreviousMonday();
      var startDate = moment(thisMonday).subtract(7, 'days').format(formatString);
      var endDate = moment(thisMonday).subtract(1, 'days').format(formatString);

      return { startDate: startDate, endDate: endDate };
    }
  }]);
  return DateHelper;
}();

var dateHelper = /*#__PURE__*/Object.freeze({
  default: DateHelper
});

var defaultValues$1 = function defaultValues(theme) {
  var typography = theme.typography,
      layout = theme.layout,
      colours = theme.colours,
      shadows = theme.shadows,
      palette = theme.palette;

  return {
    borderRadius: layout.borderRadius,
    colours: {
      calendar: {
        background: '#fff',
        border: colours.grey[300],
        text: typography.colour,
        shadow: shadows.grey[500]
      },
      input: {
        border: colours.grey[300],
        borderFocused: palette.secondary.light
      },
      day: {
        available: {
          background: colours.grey[400]
        },
        selected: {
          background: colours.blue[100],
          color: colours.grey[1000],
          text: palette.primary.text
        },
        hovered: {
          background: colours.blue[100],
          color: palette.primary.text,
          text: 'inherit'
        },
        highlighted: {
          background: colours.blue[200],
          text: colours.grey[1000],
          color: palette.primary.text
        },
        disabled: {
          background: '#fff',
          color: colours.grey[1000],
          border: colours.grey[100]
        }
      }
    }
  };
};

function getOverrides$1(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'calendar', defaultValues$1);
}

var ButtonContainer = /*#__PURE__*/styled('div', {
  label: 'ButtonContainer',
  target: 'e1my3gu80'
})('display:flex;justify-content:space-evenly;');

/**
 * Adds global styles to override the react-dates component styles for the calendar
 */
var setCalendarStyles = function setCalendarStyles(theme) {
  return emotion.injectGlobal(function () {
    var typography = theme.typography;

    var _getOverrides = getOverrides$1(theme),
        colours = _getOverrides.colours,
        borderRadius = _getOverrides.borderRadius;

    return '\n    .DateRangePicker_picker {\n        top: 34px !important;\n        left: -379px !important;\n    }\n\n    .DayPicker {\n        border: 1px solid ' + colours.calendar.border + ' !important;\n        box-shadow: 3px 3px ' + colours.calendar.shadow + ' !important;\n        font-family: ' + typography.family + ' !important;\n        color: ' + colours.calendar.text + ' !important;\n        background-color: ' + colours.calendar.background + ';\n        border-radius: ' + borderRadius + ';\n      }\n\n    .DateRangePickerInput {\n        border-color: ' + colours.input.border + ' !important;\n        border-top-left-radius: ' + borderRadius + ' !important;\n        border-bottom-left-radius: ' + borderRadius + ' !important;\n        height: inherit !important;\n    }\n\n    .DateInput {\n        width: 85px !important;\n        margin: 4px 15px 3px 8px !important;\n    }\n\n    .DateInput_input {\n        font-size: ' + typography.size + ' !important;\n        font-family: ' + typography.family + ' !important;\n        line-height: normal;\n        padding: 5px 0 !important;\n        text-align: center !important;\n        box-sizing: border-box !important;\n        border: 0 !important;\n    }\n\n    .DateInput_input__focused {\n        border: 1px solid ' + colours.input.borderFocused + ' !important;\n    }\n\n    .DateInput_fang {\n        display: none !important;\n    }\n\n    .CalendarMonth,\n    .CalendarMonthGrid {\n      background-color: ' + colours.calendar.background + ';\n    }\n\n    .DayPickerNavigation_button__default {\n      background-color: ' + colours.calendar.background + ' !important;\n      color: ' + colours.calendar.text + ' !important;\n      border-color: ' + colours.calendar.border + ' !important;\n\n      svg path {\n        fill: currentColor !important;\n      }\n\n      &:hover {\n        border-color: ' + colours.calendar.text + ' !important;\n      }\n    }\n\n    .CalendarMonth_caption,\n    .DayPicker_weekHeader {\n      color: ' + colours.calendar.text + ' !important;\n    }\n\n    .CalendarDay {\n      border: none !important;\n      vertical-align: middle;\n      color: ' + colours.day.selected.color + ';\n\n        &:not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected) {\n\n            &:hover {\n                background-color: ' + colours.day.hovered.background + ' !important;\n                color: ' + colours.day.hovered.color + ' !important;\n            }\n        }\n    }\n\n    .CalendarDay__selected.CalendarDay__today {\n      background: none !important;\n      color: ' + colours.day.selected.color + ' !important;\n      text-decoration: underline !important;\n    }\n\n    .CalendarDay__blocked_out_of_range,\n    .CalendarDay__blocked_out_of_range:active,\n    .CalendarDay__blocked_out_of_range:focus,\n    .CalendarDay__blocked_out_of_range:hover {\n        color: ' + colours.day.disabled.text + ' !important;\n        outline: 0;\n        opacity: 0.5;\n    }\n\n    .CalendarDay__selected,\n    .CalendarDay__selected:hover,\n    .CalendarDay__selected:focus,\n    .CalendarDay__selected.CalendarDay__blocked_out_of_range {\n      background: ' + colours.day.selected.background + ';\n      color: ' + colours.day.selected.text + ';\n      outline: none;\n    }\n\n    .CalendarDay__selected_span,\n    .CalendarDay__selected_span:hover,\n    .CalendarDay__selected_span.CalendarDay__blocked_out_of_range {\n      background: ' + colours.day.highlighted.background + ';\n      color: ' + colours.day.highlighted.color + ';\n      text-decoration: none;\n    }\n\n    .CalendarDay__selected_start,\n    .CalendarDay__selected_end {\n      background: ' + colours.day.selected.background + ' !important;\n      color: ' + colours.day.selected.text + ' !important;\n      text-decoration: none;\n    }\n\n    .CalendarDay__hovered_span,\n    .CalendarDay__hovered_span:hover,\n    .CalendarDay__hovered_span.CalendarDay__blocked_out_of_range {\n        background-color: ' + colours.day.highlighted.background + ' !important;\n        color: ' + colours.day.highlighted.text + ' !important;\n    }\n\n    .CalendarDay__selected_span:not(.CalendarDay__blocked_out_of_range):hover {\n        background-color: ' + colours.day.available.background + ' !important;\n        color: ' + colours.day.available.text + ' !important;\n    }\n';
  });
};

var TimeSelector = /*#__PURE__*/styled('div', {
  label: 'TimeSelector',
  target: 'emno7yx0'
})('display:flex;flex-direction:row;margin-top:5px;');

var ArrowSVG = /*#__PURE__*/styled('svg', {
  label: 'ArrowSVG',
  target: 'emno7yx1'
})('align-self:center;fill:#484848;height:24px;width:24px;');

var TimeInputContainer = /*#__PURE__*/styled('div', {
  target: 'eu8r1i70',
  label: 'TimeInputContainer'
})(function (props) {
  var _ThemeHelper$getTheme = ThemeHelper.getTheme(props.theme),
      colours = _ThemeHelper$getTheme.colours;

  var bottomColour = props.valid ? colours.grey[500] : '#c53b04';
  return '\n  max-width: 100px;\n  border-bottom: 2px solid ' + bottomColour + ';\n  display: flex;\n';
});

var TimeHeader = /*#__PURE__*/styled('p', {
  target: 'eu8r1i71',
  label: 'TimeHeader'
})(function (props) {
  var _ThemeHelper$getTheme2 = ThemeHelper.getTheme(props.theme),
      palette = _ThemeHelper$getTheme2.palette;

  var primary = palette.primary;

  return '\n  color: ' + primary.main + ';\n  font-size: 15px;\n';
});

var PeriodContainer = /*#__PURE__*/styled('div', {
  label: 'PeriodContainer',
  target: 'eu8r1i72'
})('width:30px;text-align:center;line-height:12px;display:flex;flex-direction:column;justify-content:center;');

var PeriodSelector = /*#__PURE__*/styled('p', {
  target: 'eu8r1i73',
  label: 'PeriodSelector'
})(function (props) {
  var _ThemeHelper$getTheme3 = ThemeHelper.getTheme(props.theme),
      colours = _ThemeHelper$getTheme3.colours;

  var grey = colours.grey;

  return '\n  cursor: pointer;\n  color: ' + (props.selected ? grey[600] : grey[300]) + ';\n';
});

var StylishInput = /*#__PURE__*/styled('input', {
  target: 'eu8r1i74',
  label: 'StylishInput'
})(function (props) {
  var _ThemeHelper$getTheme4 = ThemeHelper.getTheme(props.theme),
      palette = _ThemeHelper$getTheme4.palette;

  var primary = palette.primary;

  return '\n  border: none;\n  outline: none;\n  max-width: 70px;\n  font-size: 25px;\n  color: ' + primary.main + ';\n  text-align: center;\n';
});

var TimeInputStyled = /*#__PURE__*/styled('div', {
  target: 'eu8r1i75',
  label: 'TimeInputStyled'
})(function (props) {
  var _ThemeHelper$getTheme5 = ThemeHelper.getTheme(props.theme),
      typography = _ThemeHelper$getTheme5.typography;

  return '\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: ' + typography.size + ';\n    font-family: ' + typography.family + ';\n    color: ' + typography.colour + ';\n    padding: 5px;\n  ';
});

/**
 * TimeInput component
 * Allows user to input a valid time and select the period
 * Prevents user in typing an incorrect time
 * Has validation whether a time is valid or not
 * Calls onTimeChange callback prop when selection changes and is valid
 */
function TimeInput(props) {
  var _useState = React.useState(getTimeWithoutPeriodFromProps()),
      _useState2 = slicedToArray(_useState, 2),
      time = _useState2[0],
      setTime = _useState2[1];

  var _useState3 = React.useState(getPeriodFromProps()),
      _useState4 = slicedToArray(_useState3, 2),
      period = _useState4[0],
      setPeriod = _useState4[1];

  var _useState5 = React.useState(),
      _useState6 = slicedToArray(_useState5, 2),
      previousTime = _useState6[0],
      setPreviousTime = _useState6[1];

  React.useEffect(function () {
    var currentTime = '' + time + period;
    if (isTimeValid() && previousTime !== currentTime) {
      props.onTimeChange(currentTime);
      setPreviousTime(currentTime);
    }
  }, [time, period]);

  function isTimeValid() {
    return (/^(0?[1-9]|1[012]):[0-5][0-9]$/.test(time)
    );
  }

  // Gets period from default time
  // Defaults to AM
  function getPeriodFromProps() {
    return props.defaultTime && (props.defaultTime.includes('AM') || props.defaultTime.includes('PM')) ? props.defaultTime.slice(-2) : 'AM';
  }

  // This would be significantly easier to enforce with TS
  function getTimeWithoutPeriodFromProps() {
    if (!props.defaultTime || props.defaultTime.length < 4) {
      return '9:00';
    }
    var doPropsIncludePeriod = props.defaultTime.includes('AM') || props.defaultTime.includes('PM');

    if (props.defaultTime && !doPropsIncludePeriod) {
      return props.defaultTime;
    }

    return doPropsIncludePeriod ? props.defaultTime.substring(0, props.defaultTime.length - 2) : '9:00';
  }

  // Allows only time to be input
  // Controls length, char type, and appends ':' after hour
  // Regex would make it shorter, but for maintainability have implemented as below
  function handleInput(input, setValue, prevValue) {
    if (input === '') {
      setValue(input);
    }

    var _input$slice = input.slice(-1),
        _input$slice2 = slicedToArray(_input$slice, 1),
        newChar = _input$slice2[0];

    var newCharIsInvalid = isNaN(newChar) && newChar !== ':' || input.length === 2 && newChar > 2;
    var isNumNotValid = input.indexOf(':') > -1 && input.split(':')[1][0] > 5;
    var isFirstNumberZero = input.length === 1 && input[0] === '0';
    var isTooLong = input.length > 5 || input[0] !== '1' && input.length > 4;

    if (isTooLong || newCharIsInvalid || isFirstNumberZero || isNumNotValid) {
      return;
    }

    var _prevValue$slice = prevValue.slice(-1),
        _prevValue$slice2 = slicedToArray(_prevValue$slice, 1),
        prevLastValue = _prevValue$slice2[0];

    if (input.length < 3 && prevLastValue === ':') {
      if (input.length === 2) {
        setValue(input[0]);
      } else {
        setValue('');
      }
      return;
    }

    if (newChar !== ':' && (input.length === 2 || input.length === 1 && input[0] !== '1')) {
      setValue(input + ':');
      return;
    }
    setValue(input);
  }

  return React__default.createElement(
    TimeInputStyled,
    null,
    React__default.createElement(
      TimeHeader,
      null,
      props.title ? props.title : 'START TIME'
    ),
    React__default.createElement(
      TimeInputContainer,
      { valid: isTimeValid() },
      React__default.createElement(StylishInput, {
        id: props.title ? props.title : 'time-input',
        onClick: function onClick() {
          return setTime('');
        },
        value: time,
        onChange: function onChange(event) {
          return handleInput(event.target.value, setTime, time);
        }
      }),
      React__default.createElement(
        PeriodContainer,
        null,
        React__default.createElement(
          PeriodSelector,
          {
            id: 'AM',
            onClick: function onClick() {
              return setPeriod('AM');
            },
            selected: period === 'AM'
          },
          'AM'
        ),
        React__default.createElement(
          PeriodSelector,
          {
            id: 'PM',
            onClick: function onClick() {
              return setPeriod('PM');
            },
            selected: period === 'PM'
          },
          'PM'
        )
      )
    ),
    props.date && React__default.createElement(
      'div',
      { id: 'time-selector-date' },
      props.date
    )
  );
}

TimeInput.propTypes = {
  /** Default time range */
  defaultTime: PropTypes.string,
  date: PropTypes.string,
  title: PropTypes.string,
  onTimeChange: PropTypes.func.isRequired
};

/**
 * TimeRangeInput component
 * Allows users to select a time range from two TimeInputs
 * Calls onTimeChange callback prop when selection changes and is valid
 */
function TimeRangeInput(props) {
  var _useState = React.useState(props.defaultStartTime || '9:00AM'),
      _useState2 = slicedToArray(_useState, 2),
      startTime = _useState2[0],
      setStartTime = _useState2[1];

  var _useState3 = React.useState(props.defaultEndTime || '5:00PM'),
      _useState4 = slicedToArray(_useState3, 2),
      endTime = _useState4[0],
      setEndTime = _useState4[1];

  var _useState5 = React.useState(),
      _useState6 = slicedToArray(_useState5, 2),
      previousTime = _useState6[0],
      setPreviousTime = _useState6[1];

  function isTimeValid(time) {
    return (/(0?[1-9]|1[0-2]):[0-5][0-9] ?[APap][mM]$/.test(time)
    );
  }

  React.useEffect(function () {
    var currentTime = startTime + '_' + endTime;
    if (isTimeValid(startTime) && isTimeValid(endTime) && previousTime !== currentTime) {
      props.onTimeChange([startTime, endTime]);
      setPreviousTime(currentTime);
    }
  });

  var _props$labels = props.labels,
      start = _props$labels.start,
      end = _props$labels.end;


  return React__default.createElement(
    TimeSelector,
    null,
    React__default.createElement(TimeInput, {
      title: start,
      defaultTime: '9:00AM',
      date: props.startDate,
      onTimeChange: function onTimeChange(time) {
        return setStartTime(time);
      }
    }),
    React__default.createElement(
      ArrowSVG,
      { viewBox: '0, 0, 1000, 1000' },
      React__default.createElement('path', { d: 'M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z' })
    ),
    React__default.createElement(TimeInput, {
      title: end,
      defaultTime: '5:00PM',
      date: props.endDate,
      onTimeChange: function onTimeChange(time) {
        return setEndTime(time);
      }
    })
  );
}

TimeRangeInput.propTypes = {
  /** Default time range */
  defaultStartTime: PropTypes.string,
  defaultEndTime: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onTimeChange: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string
  })
};

TimeRangeInput.defaultProps = {
  labels: {
    start: 'START DATE',
    end: 'END DATE'
  }
};

var _class, _temp;

/** This validation is for Safari and Firefox browsers
 *  When you supplied '2020-1-1' as local format
 *  It will cause invalid date on moment when users are using Safari and Firefox
 */
var validatePropDateFormat = function validatePropDateFormat(props, propName, componentName) {
  var field = props[propName];
  var validDateFormatRegex = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;

  if (!validDateFormatRegex.test(field)) {
    throw new Error('Invalid prop ' + propName + ' supplied to ' + componentName + '. Validation failed.');
  }

  return null;
};

/**
 * Calendar component
 * Renders a calendar using react-dates library https://github.com/airbnb/react-dates
 * Limits what dates a user can select to meet business rules
 * Calls onDatesPicked prop when user selects both a start and end date, calls onClose prop
 * when the react-dates calendar component is closed for any reason
 */
var Calendar = (_temp = _class = function (_Component) {
  inherits(Calendar, _Component);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

    _this.manageContext = function () {
      if (_this.context[emotionTheming.channel]) {
        _this.context[emotionTheming.channel].subscribe(function (theme) {
          setCalendarStyles(ThemeHelper.getTheme({ theme: theme }));
          _this.context[emotionTheming.channel].unsubscribe();
        });
      } else {
        setCalendarStyles(ThemeHelper.getDefaultTheme());
      }
    };

    _this.manageInitialDate = function () {
      var initialDate = _this.props.initialDate;


      if (initialDate) {
        _this.setState({
          disabled: START_DATE,
          focusedInput: END_DATE
        });
      }
    };

    _this.isOutsideRange = function (date) {
      var _this$state = _this.state,
          focusedInput = _this$state.focusedInput,
          range = _this$state.range,
          weeklyRangeOnly = _this$state.weeklyRangeOnly;

      var isWithinRange = date.isAfter(range.startDate) && date.isBefore(range.endDate);

      if (!weeklyRangeOnly) {
        return !isWithinRange;
      }

      var allowedDay = focusedInput === START_DATE ? 'Monday' : 'Sunday';

      return !isWithinRange || date.format('dddd') !== allowedDay;
    };

    _this.onDatesChange = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var _this$state2 = _this.state,
          focusedInput = _this$state2.focusedInput,
          weeklyRangeOnly = _this$state2.weeklyRangeOnly;


      if (focusedInput === END_DATE && !endDate && weeklyRangeOnly) {
        // user has selected an end date earlier than the start date,
        // auto select the prev Monday as the start date and set the end date as
        // they chose
        endDate = startDate;
        startDate = moment(DateHelper.getPreviousMonday(startDate));
      }

      if (focusedInput === START_DATE) {
        // Reset endDate as user select new start date
        _this.setState({ startDate: startDate, endDate: null });
      }

      if (focusedInput === END_DATE) {
        _this.setState({ endDate: endDate });
      }

      if (startDate && endDate && focusedInput === END_DATE) {
        _this.props.onDatesPicked(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'));
      }
    };

    _this.onFocusChange = function (elementId) {
      _this.setState({ focusedInput: elementId });
    };

    _this.onTimeChange = function (time) {
      _this.props.onTimesPicked(time);
      _this.setState({ time: time });
    };

    _this.state = {
      focusedInput: props.closedOnLoad !== undefined ? !props.closedOnLoad : START_DATE,
      startDate: props.initialDate && props.initialDate.startDate ? moment(props.initialDate.startDate) : moment(),
      endDate: null,
      disabled: false,
      range: {
        startDate: moment(props.range.startDate),
        endDate: moment(props.range.endDate).add(1, 'day')
      },
      weeklyRangeOnly: props.weeklyRangeOnly !== undefined ? props.weeklyRangeOnly : true
    };
    return _this;
  }

  createClass(Calendar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.manageContext();
      this.manageInitialDate();
    }

    /**
     * Limit what days users can select in the calendar
     * Start date has to be a Monday and end date a Sunday, both dates have to be within
     * the range provided via props
     * @param date - moment date object
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          startDate = _state.startDate,
          endDate = _state.endDate,
          focusedInput = _state.focusedInput,
          disabled = _state.disabled;
      var _props = this.props,
          reactDatesConfig = _props.reactDatesConfig,
          includeTimeRange = _props.includeTimeRange,
          onDateTimeClose = _props.onDateTimeClose,
          onDateTimeSubmit = _props.onDateTimeSubmit,
          enableAccept = _props.enableAccept,
          _props$labels = _props.labels,
          _props$labels$buttons = _props$labels.buttons,
          accept = _props$labels$buttons.accept,
          cancel = _props$labels$buttons.cancel,
          timeRange = _props$labels.timeRange;

      var submitIsDisabled = !this.state.time || !this.state.startDate || !this.state.endDate || !enableAccept;

      return React__default.createElement(
        'div',
        null,
        React__default.createElement(DateRangePicker, _extends({
          displayFormat: 'DD MMM YYYY',
          disabled: disabled,
          isOutsideRange: this.isOutsideRange,
          startDate: startDate,
          startDateId: START_DATE,
          startDatePlaceholderText: 'Start date',
          endDate: endDate,
          endDateId: END_DATE,
          endDatePlaceholderText: 'End date',
          onDatesChange: this.onDatesChange,
          focusedInput: focusedInput,
          onFocusChange: this.onFocusChange,
          firstDayOfWeek: 1,
          hideKeyboardShortcutsPanel: true,
          initialVisibleMonth: function initialVisibleMonth() {
            return moment();
          },
          minimumNights: 0,
          anchorDirection: constants.ANCHOR_RIGHT,
          onClose: this.props.onClose,
          readOnly: true
        }, reactDatesConfig)),
        includeTimeRange && React__default.createElement(
          React__default.Fragment,
          null,
          React__default.createElement(TimeRangeInput, {
            startDate: this.state.startDate ? this.state.startDate.format('DD MMM YYYY').toString() : undefined,
            endDate: this.state.endDate ? this.state.endDate.format('DD MMM YYYY').toString() : undefined,
            onTimeChange: function onTimeChange(_ref2) {
              var _ref3 = slicedToArray(_ref2, 2),
                  x = _ref3[0],
                  y = _ref3[1];

              return _this2.onTimeChange([x, y]);
            },
            labels: timeRange
          }),
          React__default.createElement(
            ButtonContainer,
            null,
            React__default.createElement(Button, { primary: true, text: cancel, onClick: onDateTimeClose }),
            React__default.createElement(Button, {
              info: true,
              text: accept,
              disabled: submitIsDisabled,
              onClick: onDateTimeSubmit
            })
          )
        )
      );
    }
  }]);
  return Calendar;
}(React.Component), _class.contextTypes = defineProperty({}, emotionTheming.channel, PropTypes.shape({
  subscribe: PropTypes.func,
  unsubscribe: PropTypes.func
})), _class.propTypes = {
  /** Range to limit the date selection to */
  range: PropTypes.shape({
    startDate: validatePropDateFormat,
    endDate: validatePropDateFormat
  }).isRequired,

  /** Callback prop when dates are selected */
  onDatesPicked: PropTypes.func.isRequired,

  /** Selected date to initialize */
  initialDate: PropTypes.object,

  /** Callback prop when a valid time range is selected
   *  Return value is: [startTime, endTime]
   *  time format is: HH:MM(AMPM)
   *  Return example: [9:00AM, 5:00PM]
   */
  onTimesPicked: PropTypes.func,

  /** Callback prop when calendar is closed, either from selecting dates or cancelling date selection */
  onClose: PropTypes.func.isRequired,

  /** Whether the calendar should be closed on load */
  closedOnLoad: PropTypes.bool,

  /** Callback prop when the date time is submitted
   *  Only occurs when includeTimeRange is true
   * */
  onDateTimeSubmit: PropTypes.func,

  /** Callback prop when the date time is closed,
   *  Only occurs when includeTimeRange is true
   * */
  onDateTimeClose: PropTypes.func,

  /** Whether to only show Mon-Sun selection
   *  True by default
   * */
  weeklyRangeOnly: PropTypes.bool,

  /**
   * Whether to only allow users to select a time range as well
   * */
  includeTimeRange: PropTypes.bool,

  /** Props overrides specifically for react-dates component
   * @see <a href="https://github.com/airbnb/react-dates#make-some-awesome-datepickers">react-dates props</a>
   */
  reactDatesConfig: PropTypes.object,

  /**
   * Whether to enable the accept button or not
   * */
  enableAccept: PropTypes.bool,

  /**
   * translated labels for static text
   */
  labels: PropTypes.shape({
    buttons: PropTypes.shape({
      accept: PropTypes.string,
      cancel: PropTypes.string
    }),
    timeRange: PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string
    })
  })
}, _class.defaultProps = {
  enableAccept: true,
  labels: {
    buttons: {
      accept: 'Accept',
      cancel: 'Cancel'
    },
    timeRange: {
      start: 'START TIME',
      end: 'END TIME'
    }
  }
}, _temp);


Calendar.START_DATE = START_DATE;
Calendar.END_DATE = END_DATE;

var defaultValues$2 = function defaultValues(theme) {
  var layout = theme.layout,
      shadows = theme.shadows,
      typography = theme.typography;


  return {
    spacing: layout.spacing * 2.5,
    colours: {
      background: '#fff',
      text: typography.colour,
      shadow: shadows.black[100],
      border: '#fff'
    },
    borderRadius: layout.borderRadius,
    borderWidth: '0px',
    shadowSize: '5px'
  };
};

function getOverrides$2(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'container', defaultValues$2);
}

var ContainerWrapper = /*#__PURE__*/styled('div', {
  target: 'e1pkm3aa0',
  label: 'ContainerWrapper'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides = getOverrides$2(theme),
      spacing = _getOverrides.spacing,
      borderRadius = _getOverrides.borderRadius,
      shadowSize = _getOverrides.shadowSize,
      colours = _getOverrides.colours,
      borderWidth = _getOverrides.borderWidth;

  var typography = theme.typography;


  return '\n    margin: ' + spacing + 'px;\n    padding: ' + spacing + 'px;\n    border-radius: ' + borderRadius + ';\n    background-color: ' + colours.background + ';\n    box-shadow: ' + shadowSize + ' ' + shadowSize + ' ' + colours.shadow + ';\n    font-family: ' + typography.family + ';\n    color: ' + colours.text + ';\n    border: ' + borderWidth + ' solid ' + colours.border + ';\n\n    @media print {\n        box-shadow: none;\n    }\n  ';
});

/**
 * Container components
 * Wraps children in a white box with a shadow
 */
var Container = function Container(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React__default.createElement(
    ContainerWrapper,
    { className: className },
    children
  );
};

Container.propTypes = {
  /** React children to display inside container */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  /** Custom class to attach to parent div - use this to override any styles */
  className: PropTypes.string
};

var SortIcon = 'data:image/svg+xml;base64,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'

var ForwardIcon = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MCA1NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTAgNTU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGcgaWQ9Il94MzBfIj4KCTxwYXRoIHN0eWxlPSJmaWxsOiM3NzgwODg7IiBkPSJNMzcuOCwyNC4zYzEuOCwxLjgsMS44LDQuNywwLDYuNmwtMTkuMSwxOWMtMS44LDEuNy00LjUsMS43LTYuMywwcy0xLjktNC42LTAuMi02LjVMMjgsMjcuNgoJCUwxMi4yLDExLjdjLTAuOC0wLjktMS4zLTIuMS0xLjMtMy4zYzAtMi41LDItNC42LDQuNi00LjZjMS4zLDAsMi40LDAuNSwzLjMsMS40TDM3LjgsMjQuMyIvPgo8L2c+Cjwvc3ZnPg=='

var DownIcon = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MCA1NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTAgNTU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGcgaWQ9Il94MzBfIj4KCTxwYXRoIHN0eWxlPSJmaWxsOiM3NzgwODg7IiBkPSJNMjUuMSwzMC41bDE1LjgtMTUuOGMxLjgtMS43LDQuNS0xLjcsNi4zLDBzMS45LDQuNiwwLjIsNi41TDI4LjUsNDAuM2MtMS44LDEuOC00LjgsMS44LTYuNiwwCgkJTDIuOCwyMS4yYy0xLjgtMS44LTEuOC00LjcsMC02LjVzNC43LTEuOCw2LjUsMEwyNS4xLDMwLjUiLz4KPC9nPgo8L3N2Zz4='

var ROW_TYPE_STANDARD = 'standard';
var ROW_TYPE_NESTED = 'nested';
var ROW_TYPE_COLLAPSE_PARENT = 'collapseParent';
var ROW_TYPE_NESTED_PARENT = 'nestedParent';

var COLLAPSE_TRANSITION = 350;
var COLLAPSE_OFFSET = 150;
var COLLAPSE_STATE_OPEN = 'open';
var COLLAPSE_STATE_OPENING = 'opening';
var COLLAPSE_STATE_CLOSING = 'closing';

var defaultValues$3 = function defaultValues(theme) {
  var layout = theme.layout,
      typography = theme.typography,
      colours = theme.colours,
      palette = theme.palette;

  return {
    fontSize: typography.size,
    lineHeight: typography.lineHeight,
    spacing: layout.spacing,
    colours: {
      text: typography.colour
    },
    colGroup: {
      textAlign: 'center',
      colours: {
        background: palette.primary.main,
        text: palette.primary.text
      }
    },
    col: {
      fontSize: typography.size,
      lineHeight: typography.lineHeight,
      textAlign: 'center',
      colours: {
        background: palette.primary.main,
        text: palette.primary.text
      },
      nested: {
        borderWidth: '1px',
        fontSize: typography.info.size,
        textAlign: 'center',
        colours: {
          background: colours.grey[200],
          border: colours.grey[300],
          text: typography.colour
        }
      }
    },
    row: {
      nested: {
        colours: {
          background: colours.grey[400]
        }
      }
    },
    cell: {
      borderWidth: '1px',
      padding: layout.spacing + 'px ' + layout.spacing * 2 + 'px',
      colours: {
        border: colours.grey[300]
      }
    },
    foot: {
      colours: {
        background: palette.primary.light,
        text: palette.primary.text
      }
    },
    icon: {
      size: '16px',
      colour: null
    }
  };
};

function getOverrides$3(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'dataTable', defaultValues$3);
}

function getStylesForBlockTHeadTBody(props) {
  return '\n    display: block;\n    width: ' + props.tableWidth + ';\n    tr {\n      display: table;\n      table-layout: fixed;\n      width: 100%;\n      box-sizing: border-box;\n    }\n  ';
}

function getSharedCellStyles(props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides = getOverrides$3(theme),
      cell = _getOverrides.cell,
      fontSize = _getOverrides.fontSize,
      lineHeight = _getOverrides.lineHeight;

  return '\n    padding: ' + cell.padding + ';\n    border-width: ' + cell.borderWidth + ';\n    border-style: solid;\n    border-color: ' + cell.colours.border + ';\n    font-size: ' + fontSize + ';\n    line-height: ' + lineHeight + ';\n    vertical-align: middle;\n  ';
}

var Table = /*#__PURE__*/styled('table', {
  target: 'e1htrhz40',
  label: 'Table'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides2 = getOverrides$3(theme),
      colours = _getOverrides2.colours;

  var typography = theme.typography;

  return '\n    border-collapse: collapse;\n    border-spacing: 0;\n    table-layout: fixed;\n    font-family: ' + typography.family + ';\n    color: ' + colours.text + ';\n    width: 100%;\n  ';
});

var THead = /*#__PURE__*/styled('thead', {
  target: 'e1htrhz41',
  label: 'THead'
})(function (props) {
  return props.tableWidth && '\n      ' + getStylesForBlockTHeadTBody(props) + '\n\n      th {\n        border-bottom: none;\n      }\n      th:not(:first-of-type) {\n        border-left: none;\n      }\n    ';
});

var ColGroups = /*#__PURE__*/styled('tr', {
  target: 'e1htrhz42',
  label: 'ColGroups'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides3 = getOverrides$3(theme),
      colGroup = _getOverrides3.colGroup;

  return '\n    background-color: ' + colGroup.colours.background + ';\n    color: ' + colGroup.colours.text + ';\n  ';
});

var Cols = /*#__PURE__*/styled('tr', {
  target: 'e1htrhz43',
  label: 'Cols'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides4 = getOverrides$3(theme),
      col = _getOverrides4.col;

  return '\n    background-color: ' + col.colours.background + ';\n    color: ' + col.colours.text + ';\n  ';
});

var TH = /*#__PURE__*/styled('th', {
  target: 'e1htrhz44',
  label: 'TH'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides5 = getOverrides$3(theme),
      col = _getOverrides5.col,
      colGroup = _getOverrides5.colGroup;

  var styles = getSharedCellStyles(props);
  styles += '\n    font-size: ' + col.size + ';\n    line-height: ' + col.lineHeight + ';\n    text-align: ' + (props.isColGroup ? colGroup.textAlign : col.textAlign) + ';\n  ';
  if (props.sortable) {
    styles += '\n    > div {\n      display: flex;\n      align-items: center;\n\n      > * {\n        :first-child {\n          flex-grow: 1;\n        }\n\n        :last-child {\n          flex: 0 0 16px;\n        }\n      }\n    }\n    ';
  }
  return styles;
});

var TBody = /*#__PURE__*/styled('tbody', {
  target: 'e1htrhz45',
  label: 'TBody'
})(function (props) {
  if (props.tableWidth) {
    return '\n      ' + getStylesForBlockTHeadTBody(props) + '\n      &:not(:first-of-type) {\n        tr td {\n          border-top: none;\n        }\n      }\n\n      tr:not(:first-of-type) {\n        td {\n          border-top: none;\n        }\n      }\n\n      td:not(:first-of-type) {\n        border-left: none;\n      }\n    ';
  }
  return '';
});

var TBodyTR = /*#__PURE__*/styled('tr', {
  target: 'e1htrhz46',
  label: 'TBodyTR'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides6 = getOverrides$3(theme),
      row = _getOverrides6.row;

  var styles = '';
  if (props.rowType === ROW_TYPE_NESTED_PARENT || props.rowType === ROW_TYPE_COLLAPSE_PARENT) {
    styles += '\n      background-color: ' + row.nested.colours.background + ';\n      color: ' + row.nested.colours.text + ';\n    ';
  }
  if (props.isEmpty) {
    styles += 'text-align: center;';
  } else if (props.onClick) {
    styles += 'cursor: pointer;';
  }
  return styles;
});

var TD = /*#__PURE__*/styled('td', {
  target: 'e1htrhz47',
  label: 'TD'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides7 = getOverrides$3(theme),
      spacing = _getOverrides7.spacing;

  return '\n    ' + getSharedCellStyles(props) + '\n    ' + (props.selectable && '\n      cursor: pointer;\n      padding-top: ' + (spacing + 2) + 'px;\n      padding-bottom: ' + (spacing - 2) + 'px;\n    ') + '\n  ';
});

var NestedTBody = /*#__PURE__*/styled(TBody, {
  target: 'e1htrhz48',
  label: 'NestedTBody'
})(function (props) {
  var height = '0';
  if (props.collapseState === COLLAPSE_STATE_OPEN) {
    height = props.tableHeight ? props.tableHeight : 'auto';
  }
  return '\n    ' + (props.tableWidth && '\n      ' + getStylesForBlockTHeadTBody(props) + '\n      height: ' + height + ';\n      overflow: hidden;\n      transition: height ' + COLLAPSE_TRANSITION + 'ms;\n    ') + '\n  ';
});

var NestedTH = /*#__PURE__*/styled('th', {
  target: 'e1htrhz49',
  label: 'NestedTH'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides8 = getOverrides$3(theme),
      col = _getOverrides8.col,
      spacing = _getOverrides8.spacing;

  return '\n    background-color: ' + col.nested.colours.background + ';\n    color: ' + col.nested.colours.text + ';\n    font-size: ' + col.nested.fontSize + ';\n    border: ' + col.nested.borderWidth + ' solid ' + col.nested.colours.border + ';\n    text-align: ' + col.nested.textAlign + ';\n    padding: 0 ' + spacing * 2 + 'px;\n  ';
});

var TFoot = /*#__PURE__*/styled('tfoot', {
  target: 'e1htrhz410',
  label: 'TFoot'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides9 = getOverrides$3(theme),
      foot = _getOverrides9.foot;

  return '\n    background-color: ' + foot.colours.background + ';\n    color: ' + foot.colours.text + ';\n  ';
});

var IconBtn = /*#__PURE__*/styled('span', {
  target: 'e1htrhz411',
  label: 'IconBtn'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides10 = getOverrides$3(theme),
      icon = _getOverrides10.icon;

  return '\n    width: ' + icon.size + ';\n    float: right;\n    position: relative;\n    height: 0;\n    padding-top: ' + icon.size + ';\n    cursor: pointer;\n    ' + (icon.colour ? 'color: ' + icon.colour : '') + '\n\n    svg {\n        position: absolute;\n        top: 0;\n        left: 0;\n\n        path {\n          fill: currentColor !important;\n        }\n      }\n  ';
});

var CollapseIconBtn = /*#__PURE__*/styled(IconBtn, {
  target: 'e1htrhz412',
  label: 'CollapseIconBtn'
})(function (props) {
  return '\n  transition: transform ' + COLLAPSE_TRANSITION + 'ms;\n  transform: rotate(' + (props.open ? '180deg' : '360deg') + ');\n';
});

var TruncateText = /*#__PURE__*/styled('div', {
  target: 'e1htrhz413',
  label: 'TruncateText'
})(function (props) {
  return '\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  ' + (props.hasIcon && '\n    display: inline-block;\n    max-width: calc(100% - 25px);\n  ') + '\n';
});

var baseSort = {
  /**
   * If specified when the parent column is sorted, the nested data will be sorted as specified
   * Can choose either 'number', 'string', 'nested' or provide custom sort function
   * It will default to sort as string if not provided or invalid value
   * If 'nested' is provided this will sort only nested data, leaving parent rows unaffected
   */
  sortAs: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /* Direction that first sort should go */
  sortDir: PropTypes.oneOf(['asc', 'desc'])
};

var sortConfig = PropTypes.shape(baseSort);

var baseCol = {
  /* id should correspond to a key in the child objects in the array */
  id: PropTypes.string,

  /* Column title to display */
  name: PropTypes.string,

  /*
   * Transform function to apply to column header itself
   * Use this to display custom graphics and content
   */
  headerTransform: PropTypes.func,

  /** Indicates col header text should be on one line and truncated with an ellipsis if it exceeds the width */
  headerTruncate: PropTypes.bool,

  /*
   * Transform function to apply to fields in this column in the tbody
   * Use this to display custom graphics and content
   */
  transform: PropTypes.func,

  /** Indicates body cell text should be on one line and truncated with an ellipsis if it exceeds the width */
  truncate: PropTypes.bool,

  /* Extra classes that will be applied to the col in header and body */
  classes: PropTypes.string,

  /*
   * Callback for when user clicks a cell in the table
   * Will cause an arrow icon to be added into the cell if present
   */
  onClick: PropTypes.func
};

var colConfig = PropTypes.arrayOf(PropTypes.shape(_extends({}, baseCol, {

  sort: sortConfig,

  /* Override colspan of column heading */
  headerColSpan: PropTypes.number,

  /* Override colspan of column cells in table body */
  colSpan: PropTypes.number,

  /*
   * Only show col in the table header, do not show cells for the rows in the body
   * This can be useful when working with nested data
   */
  headerOnly: PropTypes.bool
})));

var nestedColConfig = PropTypes.shape(baseCol);

var footerColConfig = PropTypes.shape({
  /* Indicates where this item is to display, should correspond to a col id */
  id: PropTypes.string,
  /* Should correspond to a key in footerData, will display the value of this */
  footerDataId: PropTypes.string
});

var colGroupConfig = PropTypes.shape({
  /* Name to display for group */
  name: PropTypes.string,

  /* Columns that come under this group, must correspond to an id in cols array */
  colIds: PropTypes.arrayOf(PropTypes.string),

  /*
   * Transform function to apply to column group header itself
   * Use this to display custom graphics and content
   */
  headerTransform: PropTypes.func,

  /**
   * If specified will add sort icon to group header and sorting will be run on col specified
   */
  sort: PropTypes.shape(_extends({
    colId: PropTypes.string
  }, baseSort)),

  /* Extra classes that will be applied to all cols in the group in table header and body */
  classes: PropTypes.string
});

var nestedDataConfig = PropTypes.shape({
  /* id should correspond to a key in the data objects, the value of which is an array */
  id: PropTypes.string,

  cols: PropTypes.arrayOf(nestedColConfig),

  /* whether to show column headers above nested data rows */
  showHeaders: PropTypes.bool,

  /*
   * Message to display if table has no data
   * Can be string or jsx
   */
  emptyDataMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  collapse: PropTypes.shape({
    /* whether nested data is collapsible, clicking on parent row will open/close the nested data section */
    enable: PropTypes.bool,

    /* class to apply to the parent tbody when it is expanded, only used if collapse is set to true */
    expandedClass: PropTypes.string,

    /* Set to true to initially expand the first nested table, default is to collapse all initially */
    expandFirst: PropTypes.bool
  })
});

var dataTablePropTypes = {
  config: PropTypes.shape({
    cols: colConfig,

    /*
     * If you want to group columns under a heading column
     * Provide an array of arrays where each array is a new col group row
     */
    colGroups: PropTypes.arrayOf(PropTypes.arrayOf(colGroupConfig)),

    /**
     * Data that is to display under a parent row using a different col config ie. students under a group
     * The data provided as the 'data' prop must have an array field which works with the provided col config here
     * Col config is a subset of the main config.cols configuration
     */
    nestedData: nestedDataConfig,

    /* Initial sort for table, should correspond to a col id */
    defaultSort: PropTypes.string,

    /*
     * Callback for when user clicks on a row in the table
     * Leave blank to disallow selecting rows
     */
    onSelectRow: PropTypes.func,

    /*
     * Message to display if table has no data
     * Can be string or jsx
     */
    emptyDataMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

    /*
     * Config for the table footer, leave empty or set to null to not show a footer
     */
    footer: PropTypes.shape({
      /* cols that you want to display in the footer, if you want a col left blank just don't include it */
      cols: PropTypes.arrayOf(footerColConfig)
    })
  }),

  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,

    /* class to apply to the row */
    className: PropTypes.string

    /* data items will have many more properties, just the ones used directly by data table are referenced here */
  })),

  /* Data to display in the footer, will be referenced by a col object in config.footer.cols */
  footerData: PropTypes.object,

  className: PropTypes.string
};

var _class$1, _temp$1;

/**
 * DataTable component
 * Configurable table component with options to sort, transform fields, group cols, etc.
 * See ./prop-types.js file for detailed info on all configuration options
 */
var DataTable = (_temp$1 = _class$1 = function (_Component) {
  inherits(DataTable, _Component);

  function DataTable(props) {
    var _collapse2;

    classCallCheck(this, DataTable);

    var _this = possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));

    _this.sortData = function (data, config, sortField, sortConfig) {
      var cols = config.cols,
          nestedData = config.nestedData;
      var currentSort = _this.state.currentSort;


      if (!cols || cols.length === 0) {
        return;
      }

      var sortCol = cols.find(function (col) {
        return col.id === sortField;
      });
      var sortDir = 'asc';
      var sortedData = [].concat(toConsumableArray(data));

      if (sortCol) {
        var sortFieldAs = 'string';
        var sortFieldDir = 'asc';
        if (sortCol.sort) {
          var _sortCol$sort = sortCol.sort;
          sortFieldAs = _sortCol$sort.sortAs;
          sortFieldDir = _sortCol$sort.sortDir;
        }

        if (currentSort && currentSort.field === sortField) {
          sortDir = currentSort.dir === 'asc' ? 'desc' : 'asc';
        } else if (sortConfig && sortConfig.sortDir) {
          sortDir = sortConfig.sortDir;
        } else if (sortFieldDir) {
          sortDir = sortFieldDir;
        }

        var sortAs = 'string';
        if (sortConfig && sortConfig.sortAs) {
          sortAs = sortConfig.sortAs;
        } else if (sortFieldAs) {
          sortAs = sortFieldAs;
        }

        if (sortFieldAs !== 'nested') {
          sortedData = orderBy(data, _this.getSortMethod(sortAs, sortField), [sortDir]);
        }

        if (nestedData) {
          var sortFieldIdx = cols.findIndex(function (col) {
            return col.id === sortField;
          });
          var nestedCol = nestedData.cols[sortFieldIdx];
          if (nestedCol && nestedCol.sort) {
            var nestedSortMethod = _this.getSortMethod(nestedCol.sort.sortAs, nestedCol.id);
            sortedData = sortedData.map(function (row) {
              row[nestedData.id] = orderBy(row[nestedData.id], nestedSortMethod, [sortDir]);
              return row;
            });
          }
        }
      }

      _this.setState({
        sortedData: sortedData,
        currentSort: { field: sortField, dir: sortDir }
      });
    };

    _this.getSortMethod = function (sortAs, sortField) {
      if (typeof sortAs === 'function') {
        return sortAs;
      }

      // sorting on a nested property ie. points.activity
      if (sortField.indexOf('.') !== -1) {
        return function (el) {
          var nestedFieldVal = _this.getCellValue(el, sortField);
          if (sortAs === 'number') {
            return +nestedFieldVal;
          }
          return nestedFieldVal;
        };
      } else if (sortAs === 'number') {
        return function (el) {
          return +el[sortField];
        };
      }
      return [sortField];
    };

    _this.getToggledSortDir = function () {
      if (_this.state.currentSort.dir === 'asc') {
        return 'desc';
      }
      return 'asc';
    };

    _this.collapseNestedData = function (parentRowId) {
      var prevOpen = _this.state.collapse[COLLAPSE_STATE_OPEN];

      if (prevOpen === parentRowId) {
        // setting closing to row id will set height to 0 which will animate
        // setting closing to null will then remove the tbody from the DOM
        setTimeout(function () {
          _this.setCollapseState();
        }, COLLAPSE_TRANSITION + COLLAPSE_OFFSET);
        _this.setCollapseState(defineProperty({}, COLLAPSE_STATE_CLOSING, parentRowId));
      } else if (prevOpen != null) {
        var _this$setCollapseStat4;

        // setting closing to prev open will set height to 0 which will animate
        // setting opening to row id will add th tbody into the DOM with height 0
        // setting open to row id on next frame will set height to 100% which will animate
        requestAnimationFrame(function () {
          _this.calculateNestedHeight(parentRowId, function () {
            var _this$setCollapseStat2;

            return _this.setCollapseState((_this$setCollapseStat2 = {}, defineProperty(_this$setCollapseStat2, COLLAPSE_STATE_OPEN, parentRowId), defineProperty(_this$setCollapseStat2, COLLAPSE_STATE_CLOSING, prevOpen), _this$setCollapseStat2));
          });
        });
        setTimeout(function () {
          _this.setCollapseState(defineProperty({}, COLLAPSE_STATE_OPEN, parentRowId));
        }, COLLAPSE_TRANSITION + COLLAPSE_OFFSET);
        _this.setCollapseState((_this$setCollapseStat4 = {}, defineProperty(_this$setCollapseStat4, COLLAPSE_STATE_OPENING, parentRowId), defineProperty(_this$setCollapseStat4, COLLAPSE_STATE_CLOSING, prevOpen), _this$setCollapseStat4));
      } else {
        // setting opening to row id will add the tbody into the DOM with height 0
        // setting open to row id on next frame will set height to 100% which will animate
        requestAnimationFrame(function () {
          _this.calculateNestedHeight(parentRowId, function () {
            return _this.setCollapseState(defineProperty({}, COLLAPSE_STATE_OPEN, parentRowId));
          });
        });

        _this.setCollapseState(defineProperty({}, COLLAPSE_STATE_OPENING, parentRowId));
      }
    };

    _this.setCollapseState = function () {
      var _collapse;

      var collapseState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var open = collapseState[COLLAPSE_STATE_OPEN];
      var opening = collapseState[COLLAPSE_STATE_OPENING];
      var closing = collapseState[COLLAPSE_STATE_CLOSING];
      var collapse = (_collapse = {}, defineProperty(_collapse, COLLAPSE_STATE_OPEN, open != null ? open : null), defineProperty(_collapse, COLLAPSE_STATE_OPENING, opening != null ? opening : null), defineProperty(_collapse, COLLAPSE_STATE_CLOSING, closing != null ? closing : null), _collapse);

      _this.setState({ collapse: collapse });
    };

    _this.calculateNestedHeight = function (rowId, stateUpdateCallback) {
      var nestedHeights = _this.state.nestedHeights;

      if (!nestedHeights[rowId]) {
        var ref = _this.nestedRefs[rowId];
        var height = 0;
        if (ref && ref.children) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = ref.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var child = _step.value;

              var styles = window.getComputedStyle(child);
              height += parseInt(styles.getPropertyValue('height'), 10);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        nestedHeights[rowId] = height + 'px';
      }
      _this.setState({ nestedHeights: nestedHeights }, stateUpdateCallback);
    };

    _this.getColClasses = function (col) {
      var colGroups = _this.props.config.colGroups;

      var classes = '';
      if (colGroups) {
        colGroups.forEach(function (colGroupRow) {
          var colGroup = colGroupRow.find(function (group) {
            return group.colIds.indexOf(col.id) !== -1;
          });
          if (colGroup && colGroup.classes) {
            classes += ' ' + colGroup.classes;
          }
        });
      }
      if (col.classes) {
        classes += ' ' + col.classes;
      }
      return classes;
    };

    _this.getCellValue = function (row, colId) {
      var cellValue = row;
      var nestedProperties = colId.split('.');
      while (nestedProperties.length > 0) {
        cellValue = cellValue[nestedProperties.shift()];
      }
      return cellValue;
    };

    _this.getColKey = function (col, idx) {
      if (col.id != null) {
        return col.id;
      } else if (col.name) {
        return col.name;
      }
      return idx;
    };

    _this.renderHeaderSortIcon = function () {
      for (var _len = arguments.length, sortParams = Array(_len), _key = 0; _key < _len; _key++) {
        sortParams[_key] = arguments[_key];
      }

      return React__default.createElement(
        IconBtn,
        {
          role: 'button',
          onClick: function onClick() {
            return _this.sortData.apply(_this, sortParams);
          },
          tabIndex: '0'
        },
        React__default.createElement(Isvg, { src: SortIcon, cacheRequests: true })
      );
    };

    _this.getHeaderCellContent = function (header) {
      if (header.headerTransform) {
        return header.headerTransform();
      } else if (header.headerTruncate) {
        return React__default.createElement(
          TruncateText,
          null,
          header.name
        );
      }
      return React__default.createElement(
        'span',
        null,
        header.name
      );
    };

    _this.state = {
      sortedData: [],
      currentSort: { field: null, dir: null },
      collapse: (_collapse2 = {}, defineProperty(_collapse2, COLLAPSE_STATE_OPEN, null), defineProperty(_collapse2, COLLAPSE_STATE_OPENING, null), defineProperty(_collapse2, COLLAPSE_STATE_CLOSING, null), _collapse2),
      tableWidth: 'auto',
      nestedHeights: {}
    };

    _this.tableRef = null;
    _this.nestedRefs = {};
    _this.setTableWidth = _this.setTableWidth.bind(_this);
    return _this;
  }

  createClass(DataTable, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      var _props = this.props,
          config = _props.config,
          data = _props.data;

      if (config && data) {
        this.sortData(data, config, config.defaultSort);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initTableWidth(this.props.config);
      this.expandFirst(this.props);
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      var _this2 = this;

      var _props2 = this.props,
          data = _props2.data,
          config = _props2.config;
      var newData = newProps.data,
          newConfig = newProps.config;
      var sortedData = this.state.sortedData;

      var hasDataChanged = !isEqual(newData, data) || newData && newData.length > 0 && sortedData.length === 0;

      if (hasDataChanged && newConfig) {
        this.setCollapseState();
        this.setState({
          tableWidth: 'auto',
          nestedHeights: {},
          currentSort: { field: null, dir: null }
        }, function () {
          _this2.sortData(newData, newConfig, newConfig.defaultSort);
          _this2.initTable(newProps);
        });
      } else if (config !== newConfig) {
        this.initTable(newProps);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(newProps, newState) {
      var _this3 = this;

      var propsToTriggerRender = ['config', 'className', 'footerData'];
      var stateToTriggerRender = ['sortedData', 'collapse', 'tableWidth', 'nestedHeights'];
      var stateChanged = !!stateToTriggerRender.find(function (key) {
        return newState[key] !== _this3.state[key];
      });
      var propsChanged = !!propsToTriggerRender.find(function (key) {
        return newProps[key] !== _this3.props[key];
      });
      return stateChanged || propsChanged;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setTableWidth);
    }

    /**
     * Sorts the data in the table, using the config from the provided sort field
     * If the current sort is using the same field, it will reverse the sort
     *
     * @param data table data to sort
     * @param config table config
     * @param sortField id of the column we want to sort data by
     * @param sortConfig specify this if you are sorting on a field that doesn't have its own sort config
     */


    /**
     * Open/close nested data table under parent row
     * If nested data table is visible currently will hide it, else will display it
     * Only one nested table can be open at a time, so if another is open, it will close
     */


    /**
     * Sets all options of collapse state, any not passed in will be set to null
     */

  }, {
    key: 'initTable',
    value: function initTable(props) {
      this.expandFirst(props);
      this.initTableWidth(props.config);
    }

    /**
     * Store current table width value and add resize listener so can update if user resizes
     * Table width property is only used for styling collapsible nested tables
     */

  }, {
    key: 'initTableWidth',
    value: function initTableWidth(config) {
      if (get(config, ['nestedData', 'collapse', 'enable'])) {
        this.setTableWidth();
        window.removeEventListener('resize', this.setTableWidth); // remove in case it was previously added
        window.addEventListener('resize', this.setTableWidth);
      }
    }

    /**
     * Stores the calculated width of the table element, needed for styling collapsible nested tables
     */

  }, {
    key: 'setTableWidth',
    value: function setTableWidth() {
      if (this.tableRef) {
        var styles = window.getComputedStyle(this.tableRef);
        var width = styles.getPropertyValue('width');
        this.setState({ tableWidth: width });
      }
    }

    /**
     * Calculates the full height that the collapsed nested table would be when open
     * This is needed to animate the transition of open -> closed
     */

  }, {
    key: 'expandFirst',


    /**
     * Expands first nested table if config option has been set
     */
    value: function expandFirst(props) {
      var config = props.config,
          data = props.data;

      var expandFirst = get(config, ['nestedData', 'collapse', 'expandFirst']);
      if (expandFirst === true && data && data.length > 0) {
        var parentRowId = data[0].id;
        var open = this.state.collapse[COLLAPSE_STATE_OPEN];
        if (parentRowId !== open) {
          this.setState({ nestedHeights: {} });
          this.collapseNestedData(parentRowId);
        } else {
          this.calculateNestedHeight(parentRowId);
        }
      } else {
        this.setState({ nestedHeights: {} });
      }
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var _this4 = this;

      var config = this.props.config;
      var cols = config.cols,
          colGroups = config.colGroups,
          nestedData = config.nestedData;
      var _state = this.state,
          sortedData = _state.sortedData,
          tableWidth = _state.tableWidth;


      var collapseProps = {};
      if (get(nestedData, ['collapse', 'enable'])) {
        collapseProps = { tableWidth: tableWidth };
      }

      return React__default.createElement(
        THead,
        collapseProps,
        colGroups && colGroups.map(function (colGroupRow, idx) {
          return React__default.createElement(
            ColGroups,
            { key: idx },
            colGroupRow.map(function (group) {
              return React__default.createElement(
                TH,
                {
                  key: group.name,
                  colSpan: group.colIds.length,
                  className: group.classes,
                  sortable: !!group.sort,
                  isColGroup: true
                },
                React__default.createElement(
                  'div',
                  null,
                  _this4.getHeaderCellContent(group),
                  group.sort && _this4.renderHeaderSortIcon(sortedData, config, group.sort.colId, group.sort)
                )
              );
            })
          );
        }),
        React__default.createElement(
          Cols,
          null,
          cols.map(function (col, idx) {
            return React__default.createElement(
              TH,
              {
                key: _this4.getColKey(col, idx),
                className: _this4.getColClasses(col),
                colSpan: col.headerColSpan,
                sortable: !!col.sort
              },
              React__default.createElement(
                'div',
                null,
                _this4.getHeaderCellContent(col),
                col.sort && _this4.renderHeaderSortIcon(sortedData, config, col.id)
              )
            );
          })
        )
      );
    }
  }, {
    key: 'renderBody',


    /**
     * Renders main body of table
     * Handles rendering nested data and collapsible nested data if configuration has been set for these
     */
    value: function renderBody() {
      var _this5 = this;

      var _state2 = this.state,
          sortedData = _state2.sortedData,
          tableWidth = _state2.tableWidth,
          nestedHeights = _state2.nestedHeights,
          collapse = _state2.collapse;
      var _props3 = this.props,
          data = _props3.data,
          config = _props3.config;
      var emptyDataMessage = config.emptyDataMessage,
          cols = config.cols,
          nestedData = config.nestedData;

      var isCollapse = get(nestedData, ['collapse', 'enable']);

      if (data && data.length === 0 && emptyDataMessage) {
        var colSpan = cols.reduce(function (span, col) {
          var thisColSpan = 1;
          if (col.headerOnly) {
            thisColSpan = 0;
          } else if (col.colSpan != null) {
            thisColSpan = col.colSpan;
          }
          span += thisColSpan;
          return span;
        }, 0);
        return React__default.createElement(
          TBody,
          null,
          React__default.createElement(
            TBodyTR,
            { isEmpty: true },
            React__default.createElement(
              TD,
              { colSpan: colSpan },
              emptyDataMessage
            )
          )
        );
      }

      var BodyContent = [];
      var rows = [];

      sortedData.forEach(function (row) {
        var hasNestedChildren = nestedData && row[nestedData.id];
        // we add a tbody per section when we have collapsible nested tables
        if (isCollapse) {
          BodyContent.push(React__default.createElement(
            TBody,
            {
              key: row.id,
              onClick: function onClick() {
                return _this5.collapseNestedData(row.id);
              },
              tableWidth: tableWidth,
              className: collapse[COLLAPSE_STATE_OPEN] === row.id ? nestedData.collapse.expandedClass : ''
            },
            _this5.renderBodyRow(row, cols, row.id, ROW_TYPE_COLLAPSE_PARENT)
          ));
        } else {
          rows.push([_this5.renderBodyRow(row, cols, row.id, hasNestedChildren ? ROW_TYPE_NESTED_PARENT : ROW_TYPE_STANDARD)]);
        }

        if (hasNestedChildren) {
          var nestedRows = [];
          if (nestedData.showHeaders) {
            // add row for nested data col headers
            nestedRows.push(React__default.createElement(
              TBodyTR,
              { key: row.id + '-nested-head', className: row.className },
              nestedData.cols.map(function (col, idx) {
                return React__default.createElement(
                  NestedTH,
                  {
                    key: _this5.getColKey(col, idx),
                    className: _this5.getColClasses(col)
                  },
                  React__default.createElement(
                    'span',
                    null,
                    col.headerTransform ? col.headerTransform(col) : col.name
                  )
                );
              })
            ));
          }
          // add each nested data row
          row[nestedData.id].forEach(function (nestedRow) {
            nestedRows.push(_this5.renderBodyRow(nestedRow, nestedData.cols, row.id + '-' + nestedRow.id, ROW_TYPE_NESTED));
          });

          // display nested empty data message if applicable
          if (nestedRows.length === 0 && nestedData.emptyDataMessage) {
            nestedRows.push(React__default.createElement(
              TBodyTR,
              { key: row.id + '-nested-empty', isEmpty: true },
              React__default.createElement(
                TD,
                { colSpan: nestedData.cols.length },
                nestedData.emptyDataMessage
              )
            ));
          }

          if (isCollapse) {
            var collapseState = [COLLAPSE_STATE_OPEN, COLLAPSE_STATE_OPENING, COLLAPSE_STATE_CLOSING].find(function (state) {
              if (collapse[state] === row.id) {
                return state;
              }
              return false;
            });
            if (collapseState) {
              // add tbody for nested section
              BodyContent.push(React__default.createElement(
                NestedTBody,
                {
                  key: row.id + '-nested',
                  innerRef: function innerRef(ref) {
                    _this5.nestedRefs[row.id] = ref;
                  },
                  name: row.id,
                  collapseState: collapseState,
                  tableWidth: tableWidth,
                  tableHeight: nestedHeights[row.id]
                },
                nestedRows
              ));
            }
          } else {
            rows = [].concat(toConsumableArray(rows), nestedRows);
          }
        }
      });

      if (!isCollapse) {
        // if we don't have a collapsible table, just render one tbody with all the data rows
        // including nested (if applicable)
        BodyContent.push(React__default.createElement(
          TBody,
          { key: 'tbody' },
          rows
        ));
      }

      return BodyContent;
    }

    /**
     * Renders an individual row in the tbody
     */

  }, {
    key: 'renderBodyRow',
    value: function renderBodyRow(row, cols, id, rowType) {
      var _this6 = this;

      var _props$config = this.props.config,
          onSelectRow = _props$config.onSelectRow,
          configCols = _props$config.cols,
          nestedData = _props$config.nestedData;

      var maxCols = configCols.length;

      var trProps = { key: id, className: row.className, rowType: rowType };
      if (onSelectRow) {
        trProps.onClick = function () {
          return onSelectRow(row);
        };
      }

      return React__default.createElement(
        TBodyTR,
        trProps,
        cols.map(function (col, idx) {
          // Make sure all rows reach the full table width
          // When there is nested data, there may be a different number of cols between the different types of rows
          var colSpan = col.colSpan || 1;
          if (idx === cols.length - 1) {
            colSpan = maxCols - cols.length + colSpan;
          }
          var showCollapseIcon = rowType === ROW_TYPE_COLLAPSE_PARENT && idx === 0 && row[nestedData.id] && (row[nestedData.id].length > 0 || nestedData.emptyDataMessage);
          var tdProps = {
            key: row.id + '-' + _this6.getColKey(col, idx),
            className: rowType === ROW_TYPE_NESTED ? col.classes : _this6.getColClasses(col),
            colSpan: colSpan,
            selectable: col.onClick || showCollapseIcon
          };
          if (col.onClick) {
            tdProps.onClick = function () {
              return col.onClick(row);
            };
          }

          var content = _this6.renderBodyCellContent(col, row, showCollapseIcon);
          if (!content) {
            return null;
          }
          return React__default.createElement(
            TD,
            tdProps,
            content
          );
        })
      );
    }

    /**
     * Renders the content of a td in the tbody
     * Works out whether to transform data, truncate text or just render as is
     */

  }, {
    key: 'renderBodyCellContent',
    value: function renderBodyCellContent(col, row, showCollapseIcon) {
      var collapse = this.state.collapse;

      var hasIcon = col.onClick || showCollapseIcon;
      var MainContent = void 0;
      var Icon = null;

      if (!col.id || col.headerOnly) {
        return null;
      } else if (col.transform) {
        MainContent = col.transform(row);
      } else if (col.truncate) {
        MainContent = React__default.createElement(
          TruncateText,
          { hasIcon: hasIcon },
          this.getCellValue(row, col.id)
        );
      } else {
        MainContent = this.getCellValue(row, col.id);
      }

      if (showCollapseIcon) {
        Icon = React__default.createElement(
          CollapseIconBtn,
          { open: collapse[COLLAPSE_STATE_OPEN] === row.id },
          React__default.createElement(Isvg, { src: DownIcon, cacheRequests: true })
        );
      } else if (col.onClick) {
        Icon = React__default.createElement(
          IconBtn,
          null,
          React__default.createElement(Isvg, { src: ForwardIcon, cacheRequests: true })
        );
      }

      return React__default.createElement(
        'div',
        null,
        MainContent,
        Icon
      );
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var _this7 = this;

      var sortedData = this.state.sortedData;
      var _props4 = this.props,
          config = _props4.config,
          footerData = _props4.footerData;
      var footer = config.footer,
          cols = config.cols;


      if (!footer || !footerData || sortedData.length === 0) {
        return null;
      }

      return React__default.createElement(
        TFoot,
        null,
        React__default.createElement(
          'tr',
          null,
          cols.map(function (col, idx) {
            var colConfig = footer.cols.find(function (footerCol) {
              return footerCol.id === col.id;
            });
            var cellContent = colConfig ? footerData[colConfig.footerDataId] : '';
            return React__default.createElement(
              TD,
              {
                key: _this7.getColKey(col, idx),
                className: _this7.getColClasses(col)
              },
              cellContent
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _props5 = this.props,
          config = _props5.config,
          className = _props5.className;

      if (!config) {
        return null;
      }

      return React__default.createElement(
        'div',
        { className: className },
        React__default.createElement(
          Table,
          {
            innerRef: function innerRef(ref) {
              _this8.tableRef = ref;
            }
          },
          this.renderHeader(),
          this.renderBody(),
          this.renderFooter()
        )
      );
    }
  }]);
  return DataTable;
}(React.Component), _class$1.propTypes = dataTablePropTypes, _temp$1);

var CalendarIcon = 'data:image/svg+xml;base64,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'

var THIS_WEEK = 'This week';
var LAST_WEEK = 'Last week';
var THIS_SCHOOL_YEAR = 'This school year';
var CUSTOM_DATE = 'Custom date';
var CUSTOM_DATE_TIME = 'Date and Time';
var LIFETIME = 'Lifetime';

var DEFAULT_DATE_OPTIONS = [THIS_WEEK, LAST_WEEK, THIS_SCHOOL_YEAR, CUSTOM_DATE];
var DATE_OPTIONS = [].concat(DEFAULT_DATE_OPTIONS, [CUSTOM_DATE_TIME, LIFETIME]);

var UpArrowIcon = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MCA1NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTAgNTU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGcgaWQ9Il94MzBfIj4KCTxwYXRoIHN0eWxlPSJmaWxsOiM3NzgwODg7IiBkPSJNNDguMSwzOS4xTDI3LjYsMTEuOWMtMS4zLTEuNy0zLjktMS43LTUuMiwwTDEuOCwzOS4xYy0xLjYsMi4yLTAuMSw1LjIsMi42LDUuMmg0MS4xCgkJQzQ4LjIsNDQuMyw0OS43LDQxLjMsNDguMSwzOS4xeiIvPgo8L2c+Cjwvc3ZnPg=='

var defaultValues$4 = function defaultValues(theme) {
  var layout = theme.layout,
      colours = theme.colours,
      shadows = theme.shadows,
      typography = theme.typography,
      palette = theme.palette;


  return {
    borderRadius: layout.borderRadius,
    fontSize: typography.size,
    lineHeight: typography.lineHeight,
    minWidth: '100px',
    colours: {
      text: typography.colour,
      background: '#fff',
      border: colours.grey[400],
      shadow: shadows.grey[500],
      hover: colours.grey[100],
      selected: {
        background: palette.primary.main,
        text: palette.primary.text
      },
      menuIcon: {
        background: null,
        border: null
      }
    },
    arrow: {
      width: layout.spacing * 2.5 + 'px'
    },
    menuIcon: {
      padding: '0 3px'
    },
    menu: {
      shadowSize: '3px',
      minWidth: '120px',
      maxHeight: '320px',
      optionPadding: layout.spacing + 'px'
    }
  };
};

function getOverrides$4(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'dropdownMenu', defaultValues$4);
}

var DropdownMenuWrapper = /*#__PURE__*/styled('div', {
  target: 'er8h9u60',
  label: 'DropdownMenuWrapper'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);
  var typography = theme.typography;

  var _getOverrides = getOverrides$4(theme),
      colours = _getOverrides.colours,
      fontSize = _getOverrides.fontSize,
      lineHeight = _getOverrides.lineHeight,
      minWidth = _getOverrides.minWidth;

  return '\n    position: relative;\n    display: flex;\n    font-family: ' + typography.family + ';\n    color: ' + colours.text + ';\n    font-size: ' + fontSize + ';\n    line-height: ' + lineHeight + ';\n    min-width: ' + minWidth + ';\n  ';
});

var DropdownToggle = /*#__PURE__*/styled('div', {
  label: 'DropdownToggle',
  target: 'er8h9u61'
})('width:100%;');

var SelectedOption = /*#__PURE__*/styled('div', {
  label: 'SelectedOption',
  target: 'er8h9u62'
})('height:100%;');

var DownArrow = /*#__PURE__*/styled('span', {
  target: 'er8h9u63',
  label: 'DownArrow'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides2 = getOverrides$4(theme),
      arrow = _getOverrides2.arrow,
      fontSize = _getOverrides2.fontSize;

  return '\n    transform: rotate(180deg);\n    width: ' + arrow.width + ';\n    flex-shrink: 0;\n\n    svg {\n      height: ' + fontSize + ';\n    }\n  ';
});

var MenuButton = /*#__PURE__*/styled('div', {
  target: 'er8h9u64',
  label: 'MenuButton'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides3 = getOverrides$4(theme),
      borderRadius = _getOverrides3.borderRadius,
      menu = _getOverrides3.menu,
      colours = _getOverrides3.colours;

  var menuBorderRadius = props.icon ? borderRadius + ' 0 0 ' + borderRadius + ';' : borderRadius;

  return '\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: ' + menuBorderRadius + ';\n    padding: ' + menu.optionPadding + ';\n    -webkit-appearance: none;\n    border: 1px solid ' + colours.border + ';\n    box-sizing: border-box;\n    height: 100%;\n    max-width: 100%;\n    background-color: ' + colours.background + ';\n    color: ' + colours.text + ';\n    cursor: pointer;\n    ' + (props.disabled && '\n      cursor: not-allowed;\n      box-shadow: none;\n      opacity: 0.65;\n\n      &:focus {\n          outline: 0;\n      }\n    ') + '\n    &:active {\n        border-style: solid;\n    }\n\n    span {\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    }\n  ';
});

var MenuIcon = /*#__PURE__*/styled(Button, {
  target: 'er8h9u65',
  label: 'MenuIcon'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides4 = getOverrides$4(theme),
      menuIcon = _getOverrides4.menuIcon,
      borderRadius = _getOverrides4.borderRadius,
      colours = _getOverrides4.colours;

  return '\n    display: flex;\n    flex-shrink: 0;\n    border-radius: 0 ' + borderRadius + ' ' + borderRadius + ' 0;\n    padding: ' + menuIcon.padding + ';\n    box-shadow: none;\n    ' + (colours.menuIcon.background && 'background-color: ' + colours.menuIcon.background + ' !important;') + '\n    ' + (colours.menuIcon.border && 'border-color: ' + colours.menuIcon.border + ' !important;') + '\n  ';
});

var Menu = /*#__PURE__*/styled('div', {
  target: 'er8h9u66',
  label: 'Menu'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);
  var zIndex = theme.zIndex;

  var _getOverrides5 = getOverrides$4(theme),
      borderRadius = _getOverrides5.borderRadius,
      menu = _getOverrides5.menu,
      colours = _getOverrides5.colours;

  return '\n    display: ' + (props.showMenu ? 'block' : 'none') + ';\n    position: absolute;\n    border-radius: ' + borderRadius + ';\n    overflow: hidden;\n    box-shadow: ' + menu.shadowSize + ' ' + menu.shadowSize + ' ' + colours.shadow + ';\n    background-color: ' + colours.background + ';\n    width: ' + (props.hasIcon ? 'calc(100% - 38px)' : '100%') + ';\n    min-width: ' + menu.minWidth + ';\n    max-height: ' + menu.maxHeight + ';\n    overflow-y: auto;\n    z-index: ' + zIndex.dropdown + ';\n\n    ul {\n      border: 1px solid ' + colours.border + ';\n      border-radius: ' + borderRadius + ';\n      overflow: hidden;\n      list-style: none;\n      margin: 0;\n      padding: 0;\n    }\n  ';
});

var MenuItem = /*#__PURE__*/styled('li', {
  target: 'er8h9u67',
  label: 'MenuItem'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides6 = getOverrides$4(theme),
      menu = _getOverrides6.menu,
      colours = _getOverrides6.colours,
      fontSize = _getOverrides6.fontSize,
      lineHeight = _getOverrides6.lineHeight;

  return '\n    button {\n      padding: ' + menu.optionPadding + ';\n      border: none;\n      width: 100%;\n      text-align: left;\n      background-color: ' + colours.background + ';\n      border-radius: 0;\n      color: ' + colours.text + ';\n      font-size: ' + fontSize + ';\n      line-height: ' + lineHeight + ';\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n\n      &:hover {\n          background-color: ' + colours.hover + ';\n      }\n    }\n\n    ' + (props.selected && '\n        button,\n        button:hover {\n          color: ' + colours.selected.text + ';\n          background-color: ' + colours.selected.background + ';\n          border-color: ' + colours.selected.background + ';\n        }\n    ') + '\n  ';
});

var _class$2, _temp$2;

/* global document */

/**
 * DropdownMenu component
 * Displays provided options in drop down menu with selected option highlighted and
 * shown in main field
 * Calls onSelectOption callback prop when an option in the menu is clicked
 */
var DropdownMenu = (_temp$2 = _class$2 = function (_Component) {
  inherits(DropdownMenu, _Component);

  function DropdownMenu(props) {
    classCallCheck(this, DropdownMenu);

    var _this = possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));

    _this.addDocumentClickListener = function () {
      document.addEventListener('mousedown', _this.onDocumentClick, false);
    };

    _this.removeDocumentClickListener = function () {
      document.removeEventListener('mousedown', _this.onDocumentClick, false);
    };

    _this.onDocumentClick = function (event) {
      if (_this.ref.contains(event.target)) {
        return;
      }
      _this.removeDocumentClickListener();
      _this.setState({ showMenu: false });
    };

    _this.toggleMenu = function () {
      if (_this.props.disabled) {
        return;
      }
      _this.setState(function (prevState) {
        var showMenu = !prevState.showMenu;
        if (showMenu) {
          _this.addDocumentClickListener();
        } else {
          _this.removeDocumentClickListener();
        }
        return { showMenu: showMenu };
      });
    };

    _this.renderMenuOption = function (option) {
      var _this$props = _this.props,
          selectedOption = _this$props.selectedOption,
          onSelectOption = _this$props.onSelectOption;

      var isSelected = selectedOption.value === option.value;
      return React__default.createElement(
        MenuItem,
        { key: option.value, selected: isSelected },
        React__default.createElement(
          'button',
          {
            title: option.title || option.label,
            onClick: function onClick() {
              _this.toggleMenu();
              onSelectOption(option);
            }
          },
          React__default.createElement(
            React__default.Fragment,
            null,
            option.label,
            ' '
          )
        )
      );
    };

    _this.state = { showMenu: false };
    _this.ref = null;
    return _this;
  }

  createClass(DropdownMenu, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeDocumentClickListener();
    }

    /**
     * Close drop down menu if user clicks outside component
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          selectedOption = _props.selectedOption,
          options = _props.options,
          icon = _props.icon,
          className = _props.className,
          disabled = _props.disabled;
      var showMenu = this.state.showMenu;


      return React__default.createElement(
        DropdownMenuWrapper,
        {
          innerRef: function innerRef(ref) {
            _this2.ref = ref;
          },
          className: className
        },
        React__default.createElement(
          DropdownToggle,
          null,
          React__default.createElement(
            SelectedOption,
            null,
            React__default.createElement(
              MenuButton,
              {
                disabled: disabled,
                onClick: this.toggleMenu,
                icon: icon,
                role: 'button',
                tabIndex: '0',
                title: selectedOption.title || selectedOption.label
              },
              React__default.createElement(
                'span',
                null,
                selectedOption.label
              ),
              !icon && React__default.createElement(
                DownArrow,
                null,
                React__default.createElement(Isvg, { src: UpArrowIcon, cacheRequests: true })
              )
            )
          ),
          React__default.createElement(
            Menu,
            { showMenu: showMenu, hasIcon: !!icon },
            React__default.createElement(
              'ul',
              null,
              options.map(function (option) {
                return _this2.renderMenuOption(option);
              })
            )
          )
        ),
        icon && React__default.createElement(MenuIcon, {
          primary: true,
          disabled: disabled,
          icon: icon,
          onClick: this.toggleMenu
        })
      );
    }
  }]);
  return DropdownMenu;
}(React.Component), _class$2.propTypes = {
  /** Options for the dropdown list */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string
  })).isRequired,

  /** Current selected option in the dropdown list */
  selectedOption: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string
  }).isRequired,

  /** Callback for when user selects an option in dropdown list */
  onSelectOption: PropTypes.func.isRequired,

  /**
   * Icon to show in a button to the right of the dropdown, providing one will prevent a down
   * arrow icon being shown
   */
  icon: PropTypes.string,

  /* Whether dropdown is disabled, will be greyed out with not-allowed cursor */
  disabled: PropTypes.bool,

  /* Custom class name to pass through for styling */
  className: PropTypes.string
}, _class$2.defaultProps = {
  selectedOption: { label: '', value: '' },
  disabled: false
}, _temp$2);

var DatePickerWrapper = /*#__PURE__*/styled('div', {
  target: 'e1k3wnle0',
  label: 'DatePickerWrapper'
})(function (props) {
  var _ThemeHelper$getTheme = ThemeHelper.getTheme(props.theme),
      typography = _ThemeHelper$getTheme.typography;

  return '\n    display: flex;\n    font-size: ' + typography.size + ';\n    font-family: ' + typography.family + ';\n    color: ' + typography.colour + ';\n  ';
});

var _class$3, _temp$3;

/**
 * DatePicker component
 * Allows user to pick 'This week' 'Last week' 'This school year' or 'Custom date' from drop down
 * Loads Calendar component if user chooses custom date range
 * Calls onDateChange callback prop when selection changes
 */
var DatePicker = (_temp$3 = _class$3 = function (_Component) {
  inherits(DatePicker, _Component);

  function DatePicker(props) {
    classCallCheck(this, DatePicker);

    var _this = possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _this.onDateChange = function (value) {
      _this.setState({
        selectedDateType: value,
        selectedCustomDates: false,
        selectedTimeRange: false,
        dateTimeSubmitted: false
      });

      var startDate = void 0;
      var endDate = void 0;

      switch (value) {
        case THIS_WEEK:
          var _DateHelper$getThisWe = DateHelper.getThisWeekStartEnd();

          startDate = _DateHelper$getThisWe.startDate;
          endDate = _DateHelper$getThisWe.endDate;

          break;
        case LAST_WEEK:
          var _DateHelper$getLastWe = DateHelper.getLastWeekStartEnd();

          startDate = _DateHelper$getLastWe.startDate;
          endDate = _DateHelper$getLastWe.endDate;

          break;
        case THIS_SCHOOL_YEAR:
        case LIFETIME:
          var _this$props$academicY = _this.props.academicYear;
          startDate = _this$props$academicY.startDate;
          endDate = _this$props$academicY.endDate;

          break;
        case CUSTOM_DATE:
        case CUSTOM_DATE_TIME:
          return;
        default:
          console.warn('Unhandled date type'); // eslint-disable-line no-console
      }

      _this.props.onDateChange(value, startDate, endDate);
    };

    _this.onCustomDateChange = function (startDate, endDate) {
      _this.props.onDateChange(_this.state.selectedDateType, startDate, endDate);
      _this.setState({ selectedCustomDates: true });
    };

    _this.onTimeRangeChange = function (time) {
      _this.props.onTimeChange(time);
      _this.setState({ selectedTimeRange: true, time: time });
    };

    _this.onCustomDateClose = function () {
      // todo: i don't like this timeout but i couldn't get cancel functionality to
      // work without it
      setTimeout(function () {
        if (!_this.state.selectedCustomDates) {
          _this.setState({
            selectedDateType: _this.props.currentDate.type,
            selectedCustomDates: true,
            hideSelectedTime: true
          });
        }
      });
    };

    _this.onDateTimeSubmit = function () {
      _this.setState({
        selectedDateType: CUSTOM_DATE_TIME,
        selectedCustomDates: true,
        hideSelectedTime: true,
        dateTimeSubmitted: true
      });
    };

    _this.getSelectedLabel = function () {
      var selectedDateType = _this.state.selectedDateType;


      if (selectedDateType === CUSTOM_DATE || selectedDateType === CUSTOM_DATE_TIME) {
        var time = _this.state.time;
        var _this$props$currentDa = _this.props.currentDate,
            startDate = _this$props$currentDa.startDate,
            endDate = _this$props$currentDa.endDate;

        var formatString = 'DD MMM YYYY';
        var formattedStartDate = moment(startDate).format(formatString);
        var formattedEndDate = moment(endDate).format(formatString);
        return selectedDateType === CUSTOM_DATE ? formattedStartDate + ' - ' + formattedEndDate : formattedStartDate + ' ' + time[0] + ' - ' + formattedEndDate + ' ' + time[1];
      }

      return selectedDateType;
    };

    _this.state = {
      weeklyRangeOnly: props.weeklyRangeOnly !== undefined ? props.weeklyRangeOnly : true,
      selectedDateType: props.currentDate.type,
      selectedCustomDates: props.currentDate.type === CUSTOM_DATE || props.currentDate.type === CUSTOM_DATE_TIME,
      hideSelectedTime: true,
      time: ['9:00AM', '5:00PM'],
      dateTimeSubmitted: false
    };
    return _this;
  }

  createClass(DatePicker, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.selectedDateType !== nextProps.currentDate.type) {
        this.setState({
          weeklyRangeOnly: nextProps.weeklyRangeOnly !== undefined ? nextProps.weeklyRangeOnly : true,
          selectedDateType: nextProps.currentDate.type,
          selectedCustomDates: nextProps.currentDate.type === CUSTOM_DATE
        });
      }
    }

    /**
     * Runs when user changes value in dropdown
     * Calls onDateChange prop with newly selected date range (unless user chose custom date)
     */


    /**
     * Runs when user selects start & end dates in calendar component
     * Calls onDateChange prop with newly selected date range
     */


    /**
     * Reverts date to previous selection if user cancelled selecting custom dates in calendar
     */

    /**
     * Generates the display text to show in the dropdown menu as the current selected option
     * Handles showing the date range if user chose custom date ie. 14 June 2018 - 28 June 2018
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          selectedDateType = _state.selectedDateType,
          selectedCustomDates = _state.selectedCustomDates,
          hideSelectedTime = _state.hideSelectedTime,
          dateTimeSubmitted = _state.dateTimeSubmitted,
          weeklyRangeOnly = _state.weeklyRangeOnly;
      var _props = this.props,
          academicYear = _props.academicYear,
          reactDatesConfig = _props.reactDatesConfig,
          className = _props.className,
          options = _props.options,
          initialDate = _props.initialDate;

      var selectedDateLabel = this.getSelectedLabel();
      var shouldDisplayCalendar = selectedDateType === CUSTOM_DATE && !selectedCustomDates || selectedDateType === CUSTOM_DATE_TIME && !dateTimeSubmitted && (!selectedCustomDates || hideSelectedTime);
      return React__default.createElement(
        DatePickerWrapper,
        { className: className },
        shouldDisplayCalendar && React__default.createElement(Calendar, {
          range: academicYear,
          reactDatesConfig: reactDatesConfig,
          onDatesPicked: this.onCustomDateChange,
          weeklyRangeOnly: weeklyRangeOnly,
          initialDate: initialDate,
          includeTimeRange: selectedDateType === CUSTOM_DATE_TIME,
          onTimesPicked: function onTimesPicked(time) {
            return _this2.onTimeRangeChange(time);
          },
          onClose: this.onCustomDateClose,
          onSubmit: this.onDateTimeSubmit
        }),
        !shouldDisplayCalendar && React__default.createElement(DropdownMenu, {
          icon: CalendarIcon,
          options: options.map(function (option) {
            return {
              label: option,
              value: option
            };
          }),
          selectedOption: {
            label: selectedDateLabel,
            value: selectedDateType
          },
          onSelectOption: function onSelectOption(option) {
            return _this2.onDateChange(option.value);
          }
        })
      );
    }
  }]);
  return DatePicker;
}(React.Component), _class$3.propTypes = {
  /** Range to limit the date selection to */
  academicYear: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string
  }).isRequired,

  /** Current selected date */
  currentDate: PropTypes.shape({
    type: PropTypes.oneOf(DATE_OPTIONS),
    startDate: PropTypes.string,
    endDate: PropTypes.string
  }).isRequired,

  /** Options to display in dropdown menu */
  options: PropTypes.arrayOf(PropTypes.oneOf(DATE_OPTIONS)),

  /** Callback when a date selection is made */
  onDateChange: PropTypes.func.isRequired,

  initialDate: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string
  }),

  /** Flag whether custom date range should be mon-sun
   *  enabled by default
   */
  weeklyRangeOnly: PropTypes.bool,

  /** Callback when a time selection is made
   */
  onTimeChange: PropTypes.func,

  /** Custom class to attach to parent div - use this to override any styles */
  className: PropTypes.string,

  /** Props overrides for react-dates component
   * @see <a href="https://github.com/airbnb/react-dates#make-some-awesome-datepickers">react-dates props</a>
   */
  reactDatesConfig: PropTypes.object
}, _class$3.defaultProps = {
  options: DEFAULT_DATE_OPTIONS
}, _temp$3);


DatePicker.THIS_WEEK = THIS_WEEK;
DatePicker.LAST_WEEK = LAST_WEEK;
DatePicker.THIS_SCHOOL_YEAR = THIS_SCHOOL_YEAR;
DatePicker.CUSTOM_DATE = CUSTOM_DATE;
DatePicker.CUSTOM_DATE_TIME = CUSTOM_DATE_TIME;
DatePicker.LIFETIME = LIFETIME;
DatePicker.DEFAULT_DATE_OPTIONS = DEFAULT_DATE_OPTIONS;
DatePicker.DATE_OPTIONS = DATE_OPTIONS;

var ArrowLeft = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjcxOTE0IDE2LjQ0MDFDOS4zNDQyMyAxNi44MTUgOC43MzY0IDE2LjgxNSA4LjM2MTQ5IDE2LjQ0MDFMMi42MDE0OSAxMC42ODAxQzIuMjI2NTkgMTAuMzA1MiAyLjIyNjU5IDkuNjk3MzMgMi42MDE0OSA5LjMyMjQzTDguMzYxNDkgMy41NjI0M0M4LjczNjQgMy4xODc1MiA5LjM0NDIzIDMuMTg3NTIgOS43MTkxNCAzLjU2MjQzQzEwLjA5NCAzLjkzNzMzIDEwLjA5NCA0LjU0NTE3IDkuNzE5MTQgNC45MjAwN0w1LjU5Nzk2IDkuMDQxMjVIMTYuNzIwM0MxNy4yNTA1IDkuMDQxMjUgMTcuNjgwMyA5LjQ3MTA2IDE3LjY4MDMgMTAuMDAxM0MxNy42ODAzIDEwLjUzMTQgMTcuMjUwNSAxMC45NjEzIDE2LjcyMDMgMTAuOTYxM0w1LjU5Nzk2IDEwLjk2MTJMOS43MTkxNCAxNS4wODI0QzEwLjA5NCAxNS40NTczIDEwLjA5NCAxNi4wNjUyIDkuNzE5MTQgMTYuNDQwMVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg=='

var defaultValues$5 = function defaultValues(theme) {
  var layout = theme.layout,
      colours = theme.colours,
      typography = theme.typography,
      palette = theme.palette;
  var title = typography.title,
      subtitle = typography.subtitle;


  return {
    colours: {
      main: {
        background: colours.grey[400],
        text: title.colour
      },
      subtitle: {
        border: palette.primary.light,
        text: subtitle.colour
      },
      subheader: {
        background: colours.grey[200],
        text: typography.colour
      }
    },
    spacing: layout.spacing * 2.5,
    subtitle: {
      borderRadius: layout.spacing * 2.5 + 'px',
      borderWidth: '2px',
      padding: layout.spacing * 0.75 + 'px ' + layout.spacing * 2.5 + 'px'
    }
  };
};

function getOverrides$5(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'header', defaultValues$5);
}

var TitleContainer = /*#__PURE__*/styled('div', {
  target: 'e7xx99y0',
  label: 'TitleContainer'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides = getOverrides$5(theme),
      spacing = _getOverrides.spacing,
      colours = _getOverrides.colours;

  var typography = theme.typography;


  return '\n    display: flex;\n    align-items: center;\n    background-color: ' + colours.main.background + ';\n    padding: ' + spacing + 'px;\n    font-family: ' + typography.family + ';\n  ';
});

var BackButtonContainer = /*#__PURE__*/styled('button', {
  target: 'e7xx99y1',
  label: 'BackButtonContainer'
})(function () {
  return '\n    width: 84px;\n    height: 32px;\n    background: linear-gradient(104deg, #00ABE8 -2.03%, #007ACC 43.7%, #0063A7 105.46%);\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    margin-right: 10px;\n    border: none;\n    border-radius: 1000px;\n    \n    p {\n      color: white;\n      font-size: 16px;\n      font-weight: 500;\n    }\n    \n    &:hover {\n      background: linear-gradient(102deg, #007ACC 0%, #014B8B 100%);\n    }\n  ';
});

var Title = /*#__PURE__*/styled('h1', {
  target: 'e7xx99y2',
  label: 'Title'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides2 = getOverrides$5(theme),
      colours = _getOverrides2.colours;

  var title = theme.typography.title;

  return '\n    color: ' + colours.main.text + ';\n    font-size: ' + title.size + ';\n    font-weight: ' + title.weight + ';\n  ';
});

var SubTitle = /*#__PURE__*/styled('div', {
  target: 'e7xx99y3',
  label: 'SubTitle'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides3 = getOverrides$5(theme),
      subtitle = _getOverrides3.subtitle,
      colours = _getOverrides3.colours,
      spacing = _getOverrides3.spacing;

  var typography = theme.typography;

  return '\n    border: ' + subtitle.borderWidth + ' solid ' + colours.subtitle.border + ';\n    border-radius: ' + subtitle.borderRadius + ';\n    padding: ' + subtitle.padding + ';\n    margin-left: ' + spacing + 'px;\n\n    p {\n      color: ' + colours.subtitle.text + ';\n      font-size: ' + typography.subtitle.size + ';\n      font-weight: ' + typography.subtitle.weight + ';\n      margin: 0;\n    }\n  ';
});

var SubHeader = /*#__PURE__*/styled('div', {
  target: 'e7xx99y4',
  label: 'SubHeader'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides4 = getOverrides$5(theme),
      colours = _getOverrides4.colours,
      spacing = _getOverrides4.spacing;

  return '\n    background-color: ' + colours.subheader.background + ';\n    color: ' + colours.subheader.text + ';\n    padding: ' + spacing * 0.75 + 'px ' + spacing + 'px;\n  ';
});

/**
 * Header component
 * Displays title with optional subtitle
 * Also displays children as sub heading content underneath main header if provided
 */
var Header = function Header(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children,
      className = _ref.className,
      backButton = _ref.backButton;
  return React__default.createElement(
    'div',
    { className: className },
    React__default.createElement(
      TitleContainer,
      null,
      React__default.createElement(BackButton, { backButton: backButton }),
      React__default.createElement(
        Title,
        null,
        title
      ),
      subtitle && React__default.createElement(
        SubTitle,
        null,
        React__default.createElement(
          'p',
          null,
          subtitle
        )
      )
    ),
    children && React__default.createElement(
      SubHeader,
      null,
      children
    )
  );
};

var BackButton = function BackButton(_ref2) {
  var backButton = _ref2.backButton;

  if (backButton) {
    return React__default.createElement(
      BackButtonContainer,
      { onClick: backButton.clickHandler },
      React__default.createElement(Isvg, { src: ArrowLeft, cacheRequests: true }),
      React__default.createElement(
        'p',
        null,
        backButton.text
      )
    );
  }

  return null;
};

BackButton.propTypes = {
  /** Optional prop if defined renders a back button with click event manage via parent */
  backButton: PropTypes.shape({
    text: PropTypes.string,
    clickHandler: PropTypes.func
  })
};

Header.propTypes = {
  /** Main title */
  title: PropTypes.string.isRequired,
  /** Subtitle to display to right of title in a bubble */
  subtitle: PropTypes.string,
  /** React children to display in a section underneath the main header */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  /** Custom class to attach to parent div - use this to override any styles */
  className: PropTypes.string,
  /** Optional prop if defined renders a back button with click event manage via parent */
  backButton: PropTypes.shape({
    text: PropTypes.string,
    clickHandler: PropTypes.func
  })
};

var CrossIcon = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MCA1NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTAgNTU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGcgaWQ9Il94MzBfIj4KCTxwYXRoIHN0eWxlPSJmaWxsOiM3NzgwODg7IiBkPSJNNDQuNCw0MC43YzAuMSwwLjEsMC4yLDAuMiwwLjIsMC4yYzEuNywxLjgsMS42LDQuNi0wLjIsNi4yYy0xLjgsMS43LTQuNiwxLjYtNi4yLTAuMkwyNSwzMy43CgkJTDExLjgsNDYuOWMwLDAtMC4xLDAuMS0wLjIsMC4yYy0xLjgsMS43LTQuNSwxLjYtNi4yLTAuMnMtMS42LTQuNiwwLjItNi4ybDEzLjItMTMuMkw1LjYsMTQuM0M0LDEyLjYsNCwxMCw1LjYsOC4zCgkJYzEuNy0xLjcsNC40LTEuOCw2LjItMC4yTDI1LDIxLjNMMzguMiw4LjFjMCwwLDAuMS0wLjEsMC4yLTAuMmMxLjgtMS43LDQuNi0xLjYsNi4yLDAuMmMxLjcsMS44LDEuNiw0LjYtMC4yLDYuMkwzMS4yLDI3LjUKCQlMNDQuNCw0MC43Ii8+CjwvZz4KPC9zdmc+'

var defaultValues$6 = function defaultValues(theme) {
  var layout = theme.layout,
      shadows = theme.shadows,
      palette = theme.palette;


  return {
    colours: {
      overlay: shadows.black[700],
      shadow: shadows.black[200],
      background: '#fff',
      hLine: palette.primary.main,
      closeButton: '#a6a6a6',
      closeButtonHover: '#b5b5b5'
    },
    spacing: layout.spacing,
    borderRadius: layout.borderRadius,
    width: '40%',
    maxWidth: '500px',
    shadowSize: '4px'
  };
};

function getOverrides$6(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'modal', defaultValues$6);
}

var ModalWrapper = /*#__PURE__*/styled('div', {
  target: 'e170wuyx0',
  label: 'ModalWrapper'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);
  var zIndex = theme.zIndex,
      typography = theme.typography;

  var _getOverrides = getOverrides$6(theme),
      colours = _getOverrides.colours;

  return '\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: ' + colours.overlay + ';\n    z-index: ' + zIndex.modal + ';\n    font-family: ' + typography.family + ';\n  ';
});

var ModalBox = /*#__PURE__*/styled('div', {
  target: 'e170wuyx1',
  label: 'ModalBox'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides2 = getOverrides$6(theme),
      colours = _getOverrides2.colours,
      spacing = _getOverrides2.spacing,
      shadowSize = _getOverrides2.shadowSize,
      width = _getOverrides2.width,
      maxWidth = _getOverrides2.maxWidth,
      borderRadius = _getOverrides2.borderRadius;

  return '\n    text-align: center;\n    position: absolute;\n    box-shadow: ' + shadowSize + ' ' + shadowSize + ' ' + colours.shadow + ';\n    left: 50%;\n    top: 50%;\n    padding: ' + spacing * 4 + 'px;\n    transform: translate(-50%, -50%);\n    background: ' + colours.background + ';\n    width: ' + width + ';\n    max-width: ' + maxWidth + ';\n    border-radius: ' + borderRadius + ';\n    word-break: break-word;\n  ';
});

var Title$1 = /*#__PURE__*/styled('h2', {
  target: 'e170wuyx2',
  label: 'Title'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);
  var typography = theme.typography;

  var _getOverrides3 = getOverrides$6(theme),
      colours = _getOverrides3.colours,
      spacing = _getOverrides3.spacing;

  return '\n      font-size: ' + typography.modalTitle.size + ';\n      font-weight: ' + typography.modalTitle.weight + ';\n      padding-bottom: ' + spacing * 2 + 'px;\n      margin-bottom: ' + spacing * 2 + 'px;\n      border-bottom: 1px solid ' + colours.hLine + ';\n  ';
});

var BtnContainer = /*#__PURE__*/styled('div', {
  target: 'e170wuyx3',
  label: 'BtnContainer'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides4 = getOverrides$6(theme),
      spacing = _getOverrides4.spacing;

  return '\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    margin-top: ' + spacing * 2 + 'px;\n    backface-visibility: hidden;\n\n    > div {\n      margin: 0 ' + spacing + 'px;\n    }\n  ';
});

var CloseButton = /*#__PURE__*/styled('div', {
  target: 'e170wuyx4',
  label: 'CloseButton'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides5 = getOverrides$6(theme),
      colours = _getOverrides5.colours;

  return '\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  color: ' + colours.closeButton + ';\n\n  svg {\n    width: 22px;\n    height: 22px;\n\n    path {\n      fill: currentColor !important;\n    }\n  }\n\n  &:hover {\n    color: ' + colours.closeButtonHover + ';\n  }\n\n  // Browser reset\n  button {\n    border: none;\n    margin: 0;\n    padding: 0;\n    width: auto;\n    overflow: visible;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    line-height: normal;\n    -webkit-font-smoothing: inherit;\n    -moz-osx-font-smoothing: inherit;\n    -webkit-appearance: none;\n\n    &::-moz-focus-inner {\n      border: 0;\n      padding: 0;\n    }\n  }\n';
});

var modalPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    handler: PropTypes.func,
    primary: PropTypes.bool,
    danger: PropTypes.bool,
    info: PropTypes.bool,
    disabled: PropTypes.bool
  }))
});

/**
 * Modal component
 * Displays content and buttons (if provided)
 */
var Modal = function Modal(_ref) {
  var message = _ref.message,
      onClose = _ref.onClose,
      className = _ref.className;
  var buttons = message.buttons;

  if (!buttons) {
    buttons = onClose ? [{ text: 'OK', primary: true }] : [];
  }
  return React__default.createElement(
    ModalWrapper,
    { className: className },
    React__default.createElement(
      ModalBox,
      null,
      onClose && React__default.createElement(
        CloseButton,
        null,
        React__default.createElement(
          'button',
          { onClick: onClose },
          React__default.createElement(Isvg, { src: CrossIcon, cacheRequests: true })
        )
      ),
      message.title && React__default.createElement(
        Title$1,
        null,
        message.title
      ),
      message.content,
      buttons.length > 0 && React__default.createElement(
        BtnContainer,
        null,
        buttons.map(function (button) {
          // determine required props for Button component
          var styleProps = {};
          ['primary', 'danger', 'info', 'disabled'].forEach(function (buttonStyle) {
            if (button[buttonStyle]) {
              styleProps[buttonStyle] = true;
            }
          });
          return React__default.createElement(Button, _extends({}, styleProps, {
            key: uniqueId(),
            text: button.text,
            onClick: function onClick() {
              if (button.handler) {
                button.handler();
              } else {
                onClose();
              }
            }
          }));
        })
      )
    )
  );
};

Modal.propTypes = {
  onClose: PropTypes.func,
  message: modalPropType,
  className: PropTypes.string
};

/**
 * ModalManager component
 * Manages display of modals
 */
var ModalManager = function ModalManager(_ref) {
  var modals = _ref.modals,
      onClose = _ref.onClose;
  return React__default.createElement(
    'div',
    null,
    modals.map(function (modal) {
      return React__default.createElement(Modal, {
        key: modal.id,
        message: modal,
        onClose: onClose,
        className: modal.className
      });
    })
  );
};

ModalManager.propTypes = {
  modals: PropTypes.arrayOf(modalPropType),
  onClose: PropTypes.func
};

var defaultValues$7 = function defaultValues(theme) {
  var layout = theme.layout,
      typography = theme.typography;


  return {
    spacing: layout.spacing,
    fontSize: typography.size,
    lineHeight: typography.lineHeight
  };
};

function getOverrides$7(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'radio', defaultValues$7);
}

var RadioWrapper = /*#__PURE__*/styled('div', {
  target: 'ep4728d0',
  label: 'RadioWrapper'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);
  var typography = theme.typography;

  var _getOverrides = getOverrides$7(theme),
      spacing = _getOverrides.spacing,
      fontSize = _getOverrides.fontSize,
      lineHeight = _getOverrides.lineHeight;

  return '\n  display: flex;\n  align-items: center;\n  font-family: ' + typography.family + ';\n  font-size: ' + fontSize + ';\n  line-height: ' + lineHeight + ';\n\n  label {\n    padding-left: ' + spacing + 'px;\n  }\n\n  input {\n    height: ' + lineHeight + ';\n  }\n\n  ' + (props.disabled && '\n  cursor: not-allowed;\n  opacity: 0.65;\n\n  > * {\n    pointer-events: none;\n  }\n\n  input {\n    &:focus {\n      outline: 0;\n  }\n  ') + '\n';
});

/**
 * Radio component
 * Displays radio input with label
 */
var Radio = function Radio(props) {
  var value = props.value,
      label = props.label,
      name = props.name,
      selected = props.selected,
      disabled = props.disabled,
      onSelect = props.onSelect;


  return React__default.createElement(
    RadioWrapper,
    props,
    React__default.createElement('input', {
      id: value,
      type: 'radio',
      name: name,
      value: value,
      onChange: function onChange() {
        return onSelect(value);
      },
      checked: selected,
      disabled: disabled
    }),
    React__default.createElement(
      'label',
      { htmlFor: value },
      label
    )
  );
};

Radio.propTypes = {
  /** Text to display next to radio button */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** Value used by input element and passed in onSelect callback */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /** name attribute to apply to radio */
  name: PropTypes.string,
  /** Callback when user selects radio button */
  onSelect: PropTypes.func.isRequired,
  /** Select radio button */
  selected: PropTypes.bool,
  /** Radio button cannot be clicked, and displays with alpha and a not-allowec cursor */
  disabled: PropTypes.bool,
  /** Custom class to attach to parent div - use this to override any styles */
  className: PropTypes.string
};

var RIGHT$1 = 'FOOTER_RIGHT';
var LEFT$1 = 'FOOTER_LEFT';

var Footer = function Footer(_ref) {
  var alignChildren = _ref.alignChildren,
      children = _ref.children,
      className = _ref.className;
  return React__default.createElement(
    FooterWrapper,
    { alignChildren: alignChildren, className: className },
    children
  );
};

Footer.RIGHT = RIGHT$1;
Footer.LEFT = LEFT$1;

Footer.propTypes = {
  /** React children to display inside footer */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  /** Align children to left or right of footer */
  alignChildren: PropTypes.oneOf([Footer.LEFT, Footer.RIGHT]).isRequired,
  /** Custom class to attach to parent div - use this to override any styles */
  className: PropTypes.string
};

Footer.defaultProps = {
  alignChildren: Footer.LEFT
};

var defaultValues$8 = function defaultValues(theme) {
  var layout = theme.layout,
      colours = theme.colours,
      typography = theme.typography;

  return {
    colours: {
      background: colours.grey[400],
      text: typography.colour
    },
    spacing: layout.spacing * 3
  };
};

var FooterWrapper = /*#__PURE__*/styled('div', {
  target: 'efm43t20',
  label: 'FooterWrapper'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _ThemeHelper$getCompo = ThemeHelper.getComponentOverrides(theme, 'footer', defaultValues$8),
      colours = _ThemeHelper$getCompo.colours,
      spacing = _ThemeHelper$getCompo.spacing;

  var typography = theme.typography;

  var justify = props.alignChildren === Footer.RIGHT ? 'flex-end' : 'flex-start';

  return '\n    display: flex;\n    background-color: ' + colours.background + ';\n    color: ' + colours.text + ';\n    font-family: ' + typography.family + ';\n    padding: ' + spacing + 'px ' + spacing * 0.5 + 'px;\n    justify-content: ' + justify + ';\n  ';
});

var SearchIcon = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MCA1NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTAgNTU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGcgaWQ9Il94MzBfIj4KCTxwYXRoIHN0eWxlPSJmaWxsOiM3NzgwODg7IiBkPSJNNDUuMyw0OC4zTDM3LjIsMzVjLTAuMS0wLjItMC4yLTAuMy0wLjQtMC41YzMuOC0zLjYsNi04LjcsNi0xNC4xQzQyLjgsOS42LDM0LjEsMSwyMy4zLDEKCQlDMTIuOCwxLjEsNC4xLDkuOSw0LjEsMjAuNWMwLDEwLjcsOC44LDE5LjQsMTkuNSwxOS40YzIuMiwwLDQuNS0wLjQsNi42LTEuMmMwLjEsMC4yLDAuMSwwLjMsMC4yLDAuNWw4LDEzLjMKCQljMC41LDAuOCwxLjQsMS40LDIuMywxLjZjMC4zLDAuMSwwLjYsMC4xLDAuOSwwLjFjMC42LDAsMS4zLTAuMiwxLjktMC41bDAuNy0wLjRDNDUuOCw1Mi4yLDQ2LjMsNTAsNDUuMyw0OC4zeiBNOC4yLDIwLjUKCQlDOC4xLDEyLDE1LjEsNS4xLDIzLjUsNS4xYzEuMiwwLDIuNCwwLjEsMy41LDAuNGM0LDAuOSw3LjUsMy40LDkuNiw2LjljMS41LDIuNCwyLjMsNS4yLDIuMyw4LjFDMzguOSwyOSwzMiwzNiwyMy41LDM2CgkJQzE1LjEsMzUuOSw4LjMsMjkuMSw4LjIsMjAuNXogTTQyLjgsNTEuMmwtMC43LDAuNGMtMC42LDAuMy0xLjMsMC4xLTEuNi0wLjRsLTguMS0xMy4zYzAtMC4xLDAtMC4xLTAuMS0wLjIKCQljMC41LTAuMiwwLjktMC41LDEuMy0wLjdjMC40LTAuMywwLjgtMC42LDEuMi0wLjljMCwwLDAsMCwwLDAuMUw0Myw0OS42QzQzLjUsNTAuMSw0My4zLDUwLjksNDIuOCw1MS4yeiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGQ9Ik0zMi41LDE2LjJjMC4yLDAsMC40LDAsMC42LTAuMWMwLjYtMC40LDAuOC0xLjEsMC41LTEuN2MtMy41LTUuNi0xMC43LTcuMy0xNi4zLTMuOQoJCWMtMC42LDAuMy0wLjgsMS4xLTAuNCwxLjdjMC4zLDAuNiwxLjEsMC44LDEuNywwLjRjNC4zLTIuNywxMC4xLTEuNCwxMi44LDNDMzEuNywxNiwzMi4xLDE2LjIsMzIuNSwxNi4yIi8+CjwvZz4KPC9zdmc+'

var defaultValues$9 = function defaultValues(theme) {
  var layout = theme.layout,
      typography = theme.typography,
      colours = theme.colours;


  return {
    borderRadius: layout.borderRadius,
    colours: {
      border: colours.grey[400],
      menuIcon: {
        background: null,
        border: null
      }
    },
    spacing: layout.spacing,
    fontSize: typography.size,
    lineHeight: typography.lineHeight
  };
};

function getOverrides$8(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'search', defaultValues$9);
}

var SearchWrapper = /*#__PURE__*/styled('div', {
  label: 'SearchWrapper',
  target: 'e137fzqk0'
})('display:flex;');

var Input = /*#__PURE__*/styled('input', {
  target: 'e137fzqk1',
  label: 'Input'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides = getOverrides$8(theme),
      borderRadius = _getOverrides.borderRadius,
      colours = _getOverrides.colours,
      spacing = _getOverrides.spacing,
      fontSize = _getOverrides.fontSize,
      lineHeight = _getOverrides.lineHeight;

  return '\n    flex-grow: 1;\n    border-radius: ' + borderRadius + ' 0 0 ' + borderRadius + ';\n    border: 1px solid ' + colours.border + ';\n    padding: ' + spacing + 'px;\n    font-size: ' + fontSize + ';\n    line-height: ' + lineHeight + ';\n  ';
});

var SearchButton = /*#__PURE__*/styled(Button, {
  target: 'e137fzqk2',
  label: 'SearchButton'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides2 = getOverrides$8(theme),
      spacing = _getOverrides2.spacing,
      borderRadius = _getOverrides2.borderRadius,
      colours = _getOverrides2.colours;

  return '\n    flex: 0 0 auto;\n    border-radius: 0 ' + borderRadius + ' ' + borderRadius + ' 0;\n    padding: ' + spacing * 0.25 + 'px;\n    box-shadow: none;\n    ' + (colours.menuIcon.background && 'background-color: ' + colours.menuIcon.background + ' !important;') + '\n    ' + (colours.menuIcon.border && 'border-color: ' + colours.menuIcon.border + ' !important;') + '\n  ';
});

var _class$4, _temp$4;

var Search = (_temp$4 = _class$4 = function (_Component) {
  inherits(Search, _Component);

  function Search(props) {
    classCallCheck(this, Search);

    var _this = possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _this.handleChange = function (event) {
      var onType = _this.props.onType;

      var searchString = event.target.value || '';
      _this.setState({ searchString: searchString });

      if (typeof onType === 'function') {
        onType(searchString);
      }
    };

    _this.handleClick = function () {
      var onSearch = _this.props.onSearch;
      var searchString = _this.state.searchString;

      if (typeof onSearch === 'function') {
        onSearch(searchString);
      }
    };

    _this.handleKeyDown = function (event) {
      if (event.key === 'Enter') {
        _this.handleClick();
      }
    };

    _this.state = {
      searchString: ''
    };
    return _this;
  }

  createClass(Search, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          placeholder = _props.placeholder,
          showIcon = _props.showIcon;
      var searchString = this.state.searchString;


      return React__default.createElement(
        SearchWrapper,
        null,
        React__default.createElement(Input, {
          type: 'text',
          placeholder: placeholder,
          value: searchString,
          onChange: this.handleChange,
          onKeyDown: this.handleKeyDown
        }),
        showIcon && React__default.createElement(SearchButton, { icon: SearchIcon, primary: true, onClick: this.handleClick })
      );
    }
  }]);
  return Search;
}(React.Component), _class$4.propTypes = {
  /* Search input placeholder */
  placeholder: PropTypes.string,
  /* Whether to display the button with magnifying glass icon */
  showIcon: PropTypes.bool,
  /* Callback when search button clicked or enter key pressed */
  onSearch: PropTypes.func,
  /* Callback when search input text changes */
  onType: PropTypes.func
}, _class$4.defaultProps = {
  placeholder: 'Search',
  showIcon: true
}, _temp$4);

var defaultValues$a = function defaultValues(theme) {
  var layout = theme.layout,
      colours = theme.colours,
      typography = theme.typography;
  var title = typography.title;


  return {
    colours: {
      main: {
        background: colours.grey[400],
        text: title.colour
      }
    },
    spacing: layout.spacing * 1.5
  };
};

function getOverrides$9(theme) {
  return ThemeHelper.getComponentOverrides(theme, 'legend', defaultValues$a);
}

var Icon$1 = /*#__PURE__*/styled('div', {
  target: 'e1frumd60',
  label: 'Icon'
})(function (props) {
  var color = props.color;

  return '\n  .isvg {\n    display: flex;\n    align-item: center;\n    height: 25px;\n    width: 25px;\n    margin-right: 10px;\n  }\n\n  svg {\n    height: 100%;\n    width: 100%;\n\n    path {\n      fill: ' + color + ' !important;\n    }\n  }\n';
});

var LegendContainer = /*#__PURE__*/styled('div', {
  target: 'e1frumd61',
  label: 'LegendContainer'
})(function (props) {
  var theme = ThemeHelper.getTheme(props);

  var _getOverrides = getOverrides$9(theme),
      spacing = _getOverrides.spacing,
      colours = _getOverrides.colours;

  var typography = theme.typography;


  return '\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      background-color: ' + colours.main.background + ';\n      padding: ' + spacing + 'px;\n      font-family: ' + typography.family + ';\n      width: 180px;\n      z-index: 9999;\n\n      .row {\n        width: 170px;\n        display: flex;\n        padding: 5px 0px;\n      }\n    ';
});

var ColorBlock = /*#__PURE__*/styled('span', {
  target: 'e1frumd62',
  label: 'ColorBlock'
})(function (props) {
  return '\n    width: 25px;\n    height: 25px;\n    background-color: ' + props.color + ';\n    margin-right: 10px;\n';
});

/**
 * Legend component
 * Displays legend with colors/icons and text
 */

var renderIcon = function renderIcon(icon) {
  var iconColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return React__default.createElement(
    Icon$1,
    { color: iconColor, key: 1 },
    React__default.createElement(Isvg, { src: icon, cacheRequests: true })
  );
};

var renderColor = function renderColor(color) {
  return React__default.createElement(ColorBlock, { color: color });
};

var renderRow = function renderRow(row) {
  var color = row.color,
      icon = row.icon,
      text = row.text,
      iconColor = row.iconColor;

  if (icon) {
    return [renderIcon(icon, iconColor), text];
  }
  return [renderColor(color), text];
};

var renderItems = function renderItems(items) {
  var rows = [];
  for (var row in items) {
    rows.push(React__default.createElement(
      'div',
      { className: 'row', key: items[row].text },
      renderRow(items[row])
    ));
  }
  return rows;
};

var Legend = function Legend(_ref) {
  var items = _ref.items,
      visible = _ref.visible;

  if (visible && items.length) {
    return React__default.createElement(
      LegendContainer,
      null,
      renderItems(items)
    );
  }
  return null;
};

Legend.propTypes = {
  /** Values to be displayed inside of legend (can be combined with icon/color) */
  items: PropTypes.array.isRequired,

  /** Show/Hide the Legend */
  visible: PropTypes.bool.isRequired
};

Legend.defaultProps = {
  items: []
};

var LoaderWrapper = /*#__PURE__*/styled('span', {
  target: 'e1vdh8920',
  label: 'LoaderWrapper'
})(function (props) {
  var _ThemeHelper$getTheme = ThemeHelper.getTheme(props),
      palette = _ThemeHelper$getTheme.palette;

  return '\n  display: inline-block;\n  position: relative;\n  width: 64px;\n  min-height: 15px;\n\n  div {\n    position: absolute;\n    top: 35%;\n    width: 11px;\n    height: 11px;\n    border-radius: 50%;\n    background: ' + palette.primary.light + ';\n    animation-timing-function: cubic-bezier(0, 1, 1, 0);\n  }\n\n  div:nth-child(1) {\n    left: 6px;\n    animation: lds-ellipsis1 0.6s infinite;\n  }\n\n  div:nth-child(2) {\n    left: 6px;\n    animation: lds-ellipsis2 0.6s infinite;\n  }\n\n  div:nth-child(3) {\n    left: 26px;\n    animation: lds-ellipsis2 0.6s infinite;\n  }\n\n  div:nth-child(4) {\n    left: 45px;\n    animation: lds-ellipsis3 0.6s infinite;\n  }\n\n  @keyframes lds-ellipsis1 {\n    0% {\n      transform: scale(0);\n    }\n  \n    100% {\n      transform: scale(1);\n    }\n  }\n  \n  @keyframes lds-ellipsis3 {\n    0% {\n      transform: scale(1);\n    }\n  \n    100% {\n      transform: scale(0);\n    }\n  }\n  \n  @keyframes lds-ellipsis2 {\n    0% {\n      transform: translate(0, 0);\n    }\n  \n    100% {\n      transform: translate(19px, 0);\n    }\n  }';
});

var Loader = function Loader() {
  return React__default.createElement(
    LoaderWrapper,
    null,
    React__default.createElement('div', null),
    React__default.createElement('div', null),
    React__default.createElement('div', null),
    React__default.createElement('div', null)
  );
};

var getColors = function getColors(props, palette, typography) {
  var bgColor = '#fff';
  var textColor = typography.color;

  if (props.primary) {
    bgColor = palette.primary.main;
    textColor = palette.primary.text;
  } else if (props.error) {
    bgColor = palette.error.main;
    textColor = palette.error.text;
  } else if (props.warning) {
    bgColor = palette.warning.main;
    textColor = palette.warning.text;
  } else if (props.success) {
    bgColor = palette.success.main;
    textColor = palette.success.text;
  }

  return { bgColor: bgColor, textColor: textColor };
};

var ToastWrapper = /*#__PURE__*/styled('div', {
  target: 'e1hyb6tp0',
  label: 'ToastWrapper'
})(function (props) {
  var _ThemeHelper$getTheme = ThemeHelper.getTheme(props),
      typography = _ThemeHelper$getTheme.typography,
      layout = _ThemeHelper$getTheme.layout,
      palette = _ThemeHelper$getTheme.palette;

  var spacing = layout.spacing;
  var duration = props.duration;

  var _getColors = getColors(props, palette, typography),
      bgColor = _getColors.bgColor,
      textColor = _getColors.textColor;

  return '\n        display: flex;\n        font-family: ' + typography.family + ';\n        font-size: ' + typography.subtitle.size + ';\n        width: 95%;\n        height: 50px;\n        padding: ' + spacing + 'px ' + spacing * 0.5 + 'px;\n        border-radius: 5px;\n        color: ' + textColor + ';\n        background-color: ' + bgColor + ';\n        justify-content: center;\n        align-items: center;\n        margin-bottom: ' + spacing * 2 + 'px;\n        user-select: none;\n        animation: anim ' + duration + 's;\n        animation-iteration-count: 1;\n        animation-fill-mode: forwards;\n\n        @keyframes anim {\n            0% {\n              opacity: 0;\n            }\n          \n            25% {\n              opacity: 1;\n            }\n          \n            75% {\n              opacity: 1;\n            }\n          \n            100% {\n              opacity: 0;\n            }\n    ';
});

var Icon$2 = /*#__PURE__*/styled('span', {
  label: 'Icon',
  target: 'e1hyb6tp1'
})('height:20px;width:20px;margin:0px 10px;svg{height:100%;width:100%;path{fill:currentColor !important;}}');

var TEXT_ONLY$1 = 'TEXT_ONLY';
var ICON_AND_TEXT$1 = 'ICON_AND_TEXT';

var LEFT$2 = 'LEFT';
var RIGHT$2 = 'RIGHT';

var Toaster = function Toaster(props) {
  var icon = props.icon,
      text = props.text,
      alignIcon = props.alignIcon;


  function renderIcon() {
    return React__default.createElement(
      Icon$2,
      { key: uniqueId() },
      React__default.createElement(Isvg, { src: icon, cacheRequests: true })
    );
  }

  var toasterState = TEXT_ONLY$1;
  if (icon && text) {
    toasterState = ICON_AND_TEXT$1;
  }

  function getContent() {
    if (toasterState === ICON_AND_TEXT$1) {
      if (alignIcon === Toaster.LEFT) {
        return [renderIcon(), text];
      }
      return [text, renderIcon()];
    }
    return text;
  }

  return React__default.createElement(
    ToastWrapper,
    props,
    getContent()
  );
};

Toaster.LEFT = LEFT$2;
Toaster.RIGHT = RIGHT$2;

Toaster.propTypes = {
  /** Text to display inside of toaster (can be combined with icon) */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Icon to display inside of toaster (can be combined with text) */
  icon: PropTypes.string,
  /** The duration (in seconds) for which the toaster is shown */
  duration: PropTypes.number,
  /** Use primary styles */
  primary: PropTypes.bool,
  /** Use success styles */
  success: PropTypes.bool,
  /** Use warning styles */
  warning: PropTypes.bool,
  /** Use error styles */
  error: PropTypes.bool,
  /** If using both icon and text, aligns icon to side of text */
  alignIcon: PropTypes.oneOf([Toaster.LEFT, Toaster.RIGHT])
};

Toaster.defaultProps = {
  text: '',
  duration: 5,
  primary: false,
  success: false,
  warning: false,
  error: false,
  alignIcon: Toaster.RIGHT
};

var Wrapper = /*#__PURE__*/styled('div', {
  label: 'Wrapper',
  target: 'em67ner0'
})('cursor:pointer;');

var Icon$3 = /*#__PURE__*/styled('div', {
  target: 'em67ner1',
  label: 'Icon'
})(function (props) {
  var color = props.color;

  return '\n    .isvg {\n      display: flex;\n      align-item: center;\n      height: 25px;\n      width: 25px;\n      margin-right: 10px;\n    }\n  \n    svg {\n      height: 100%;\n      width: 100%;\n  \n      path {\n        fill: ' + color + ' !important;\n      }\n    }\n  ';
});

var Content = /*#__PURE__*/styled('p', {
  label: 'Content',
  target: 'em67ner2'
})();

var ModalWrapper$1 = /*#__PURE__*/styled('div', {
        target: 'eigyztg0',
        label: 'ModalWrapper'
})(function (props) {
        var _ThemeHelper$getTheme = ThemeHelper.getTheme(props),
            colours = _ThemeHelper$getTheme.colours;

        return '\n        display: flex;\n        align-items: center;\n        background: #fff;\n        position: fixed;\n        left: ' + props.positionX + 'px;\n        top: ' + props.positionY + 'px;\n        border-radius: 8px;\n        z-index: 99;\n        box-shadow: 4px 2px 6px;\n        overflow: hidden;\n        width:' + props.modalWidth + 'px;\n        min-width: ' + props.modalWidth + 'px !important;\n        min-height: 100px;\n        cursor: default;\n        border: 1px solid #fff;\n        color: ' + colours.grey[900] + ';\n\n        ::after {\n                width: 0; \n                height: 0; \n                border-left: 8px solid transparent;\n                border-right: 8px solid transparent;        \n                border-bottom: 15px solid #fff;\n                position: fixed;\n                top: ' + (props.positionY - 20) + 'px;\n                left: ' + (props.positionArrow - 8) + 'px;\n                content: \' \';\n        }\n        * {\n                color: ' + colours.grey[900] + ';\n                background: #fff;\n                &:hover {\n                        color: ' + colours.grey[900] + ';\n                }\n        }\n\n        ';
});

var Content$1 = /*#__PURE__*/styled('div', {
        label: 'Content',
        target: 'eigyztg1'
})('font-size:13px;flex-direction:column;width:200px;max-width:225px;max-height:230px;overflow-y:auto;padding:10px;');

var ContentTheme = /*#__PURE__*/styled('div', {
        target: 'eigyztg2',
        label: 'ContentTheme'
})(function (props) {
        var _ThemeHelper$getTheme2 = ThemeHelper.getTheme(props),
            colours = _ThemeHelper$getTheme2.colours;

        return '\n        flex-direction: column;\n        width: 100%;\n        padding: 10px;\n        color: ' + colours.grey[900] + ';\n        ';
});

var ContextModalWidth = 203;

var ContextModal = function ContextModal(props) {
  if (!props.show) return null;

  return React__default.createElement(
    ModalWrapper$1,
    {
      positionArrow: props.positionArrow,
      positionX: props.positionX,
      positionY: props.positionY,
      modalWidth: ContextModalWidth
    },
    React__default.createElement(
      Content$1,
      null,
      props.content
    )
  );
};

ContextModal.propTypes = {
  show: PropTypes.bool,
  positionX: PropTypes.number,
  positionY: PropTypes.number,
  positionArrow: PropTypes.number,
  content: PropTypes.string.isRequired
};

ContextModal.defaultProps = {
  ContextModalWidth: 200
};

function getContextCoords(position, modalWidth) {
  var leftOffset = position.left || position.x || position.clientX;
  var innerOffsetRight = window.innerWidth - (position.right || position.clientX);
  var innerOffsetLeft = leftOffset - modalWidth;
  var coords = {};

  coords.posY = (position.bottom || position.clientY) + 5;
  coords.posArrow = leftOffset + (position.width || 2) / 2;
  if (innerOffsetRight > modalWidth && innerOffsetLeft > modalWidth) {
    coords.posX = coords.posArrow - modalWidth / 2; // center aligned
  } else if (innerOffsetLeft < modalWidth && innerOffsetRight > modalWidth) {
    coords.posX = coords.posArrow - 15; // left aligned
  } else {
    coords.posX = coords.posArrow - modalWidth + 15; // right aligned
  }
  return coords;
}

var OutsideClickHandler = function (_Component) {
  inherits(OutsideClickHandler, _Component);

  function OutsideClickHandler(props) {
    classCallCheck(this, OutsideClickHandler);

    var _this = possibleConstructorReturn(this, (OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call(this, props));

    _this.wrapperRef = null;

    _this.setWrapperRef = function (element) {
      _this.wrapperRef = element;
    };

    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }

  createClass(OutsideClickHandler, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps() {
      var _this2 = this;

      document.addEventListener('mousedown', this.handleClickOutside);

      return function () {
        document.removeEventListener('mousedown', _this2.handleClickOutside);
      };
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(event) {
      var forButton = this.props.forButton;

      var target = event.target;

      if (this.wrapperRef && !this.wrapperRef.contains(target) && !isIgnoredItem(target)) {
        this.props.callback();
      }

      function isIgnoredItem(t) {
        var parent = t.parentNode;

        return forButton === t.id || parent && isIgnoredItem(parent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React__default.createElement(
        'div',
        { ref: this.setWrapperRef },
        this.props.children
      );
    }
  }]);
  return OutsideClickHandler;
}(React.Component);

OutsideClickHandler.propTypes = {
  children: PropTypes.any,
  callback: PropTypes.func,
  forButton: PropTypes.string
};

var InfoCallout = function (_Component) {
  inherits(InfoCallout, _Component);

  function InfoCallout(props) {
    classCallCheck(this, InfoCallout);

    var _this = possibleConstructorReturn(this, (InfoCallout.__proto__ || Object.getPrototypeOf(InfoCallout)).call(this, props));

    _this.showContextModal = function () {
      var _getContextCoords = getContextCoords(_this.wrapperRef.getBoundingClientRect(), ContextModalWidth),
          posX = _getContextCoords.posX,
          posY = _getContextCoords.posY,
          posArrow = _getContextCoords.posArrow;

      var showCallOut = _this.state.showCallOut;


      _this.setState({
        showCallOut: !showCallOut,
        positionY: posY,
        positionX: posX,
        positionArrow: posArrow
      });
    };

    _this.showCallOut = function () {
      _this.setState({ showCallOut: false });
    };

    _this.hideCallOut = function () {
      _this.setState({
        showCallOut: false
      });
    };

    _this.state = {
      showCallOut: false,
      positionArrow: 0,
      positionXCallout: 0,
      positionYCallout: 0,
      positionX: 0,
      positionY: 0,
      positionArrowCallout: 0
    };

    _this.wrapperRef = null;

    _this.setInfoCalloutRef = function (element) {
      _this.wrapperRef = element;
    };
    return _this;
  }

  createClass(InfoCallout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('scroll', this.showCallOut);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.showCallOut);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          positionArrow = _state.positionArrow,
          positionX = _state.positionX,
          positionY = _state.positionY,
          showCallOut = _state.showCallOut;


      return React__default.createElement(
        'div',
        {
          id: this.props.id,
          role: 'button',
          tabIndex: '-1',
          onClick: this.showContextModal,
          ref: this.setInfoCalloutRef
        },
        React__default.createElement(
          Icon$3,
          null,
          React__default.createElement(Isvg, { src: this.props.icon, cacheRequests: true })
        ),
        React__default.createElement(
          OutsideClickHandler,
          {
            callback: this.hideCallOut,
            forButton: this.props.id
          },
          React__default.createElement(ContextModal, {
            positionArrow: positionArrow,
            positionX: positionX,
            positionY: positionY,
            show: showCallOut,
            content: this.props.content
          })
        )
      );
    }
  }]);
  return InfoCallout;
}(React.Component);

InfoCallout.propTypes = {
  /** The content to be displayed inside the callout component */
  content: PropTypes.string.isRequired,
  /** The default icon - which will be clickable */
  icon: PropTypes.string.isRequired,
  /** The unique id for each callout */
  id: PropTypes.string.isRequired
};

InfoCallout.defaultProps = {
  content: '',
  icon: '',
  id: 'info'
};

var palette$1 = {
  primary: {
    light: '#a2bdd3',
    main: '#278bcb',
    dark: '#1981c4',
    text: '#fff'
  }
};

var typography$1 = {
  title: {
    weight: defaultTheme.typography.weightNormal
  },
  subtitle: {
    size: '15px',
    weight: defaultTheme.typography.weightBold,
    colour: palette$1.primary.main
  }
};

var colours$1 = {
  grey: {
    100: '#eef2f5',
    200: '#e9eef2',
    300: '#e5e5e5',
    400: '#dbe3e9',
    500: '#adb6bc',
    600: '#6c7378'
  }
};

var layout$1 = {
  borderRadius: '3px'
};

var overrides$1 = {
  dropdownMenu: {
    menu: { optionPadding: '10px 8px' }
  }
};

var index = {
  palette: palette$1,
  typography: typography$1,
  colours: colours$1,
  layout: layout$1,
  overrides: overrides$1
};

var palette$2 = {
  primary: {
    light: '#51d4ae',
    main: '#37ba94',
    dark: '#2ab28a',
    text: '#fff'
  }
};

var typography$2 = {
  colour: '#444',
  title: {
    colour: '#444',
    size: '25px',
    lineheight: '35px'
  },
  subtitle: {
    colour: '#444'
  }
};

var layout$2 = {
  borderRadius: '7px'
};

var colours$2 = {
  grey: {
    100: '#f0f0f0',
    200: '#e1e1e1',
    300: '#e1e1e1',
    400: '#ebebeb',
    500: '#dfdddd',
    600: '#d6d6d6',
    700: '#999b9d',
    800: '#808080',
    900: '#444',
    1000: '#757575'
  },
  blue: {
    100: '#7ca2bb',
    200: '#c3d5e1'
  }
};

// todo: don't hardcode colours
var overrides$2 = {
  button: {
    fontSize: '16px',
    lineHeight: '22px',
    boxShadow: '3px 3px rgba(72, 72, 72, 0.3)',
    minWidth: '120px',
    size: {
      small: {
        icon: 16,
        deltaX: 1.3,
        deltaY: 1.1
      }
    }
  },
  container: {
    colours: {
      background: '#ebebeb',
      border: '#dfdddd',
      shadow: 'rgba(72, 72, 72, 0.16)'
    },
    borderWidth: '1px',
    shadowSize: '3px'
  },
  dataTable: {
    col: {
      fontSize: '12px',
      lineHeight: '20px',
      textAlign: 'left',
      colours: {
        background: '#f0f0f0',
        text: '#444'
      }
    },
    colGroup: {
      colours: {
        background: '#dfdddd',
        text: '#444'
      }
    },
    cell: {
      borderWidth: '0 0 1px 0',
      padding: '18px 10px'
    },
    foot: {
      colours: {
        background: '#dfdddd',
        text: '#444'
      }
    },
    icon: {
      colour: '#808080'
    }
  },
  dropdownMenu: {
    borderRadius: '0px',
    colours: {
      border: '#d6d6d6',
      selected: {
        background: '#dfdddd',
        text: '#444'
      },
      menuIcon: {
        background: '#1576b4',
        border: '#2f659c'
      }
    }
  },
  header: {
    colours: {
      main: {
        background: '#e4e4e4'
      },
      subtitle: {
        border: '#808080'
      }
    }
  },
  modal: {
    spacing: 12
  },
  search: {
    borderRadius: '0px',
    colours: {
      border: '#d6d6d6',
      menuIcon: {
        background: '#1981c4',
        border: '#1576b4'
      }
    }
  }
};

var index$1 = {
  palette: palette$2,
  typography: typography$2,
  layout: layout$2,
  colours: colours$2,
  overrides: overrides$2
};

/**
 * ThemeProvider component
 * Provides theme to all child component, use to wrap whole app or a group of components
 * that require the same theme
 * The provided theme object will be recursively merged with the base theme, so if any theme
 * items are missing, it will use those from the base theme instead
 *
 * @example
 * Both DatePicker & DropdownMenu components will use the myThemeObj provided
 *
 * <ThemeProvider theme={myThemeObj}>
 *  <DatePicker {...datePickerProps} />
 *  <DropdownMenu {...dropdownMenuProps} />>
 * </ThemeProvider>
 */

function ThemeProvider(props) {
  var _useState = React.useState(ThemeHelper.getTheme(props)),
      _useState2 = slicedToArray(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  React.useEffect(function () {
    setTheme(ThemeHelper.getTheme(props));
  }, [props]);

  return !theme ? null : React__default.createElement(
    emotionTheming.ThemeProvider,
    { theme: theme },
    props.children
  );
}

ThemeProvider.propTypes = {
  theme: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
  children: PropTypes.object
};

exports.DateHelper = dateHelper;
exports.Button = Button;
exports.Calendar = Calendar;
exports.Container = Container;
exports.DataTable = DataTable;
exports.DatePicker = DatePicker;
exports.DropdownMenu = DropdownMenu;
exports.Header = Header;
exports.ModalManager = ModalManager;
exports.Radio = Radio;
exports.Footer = Footer;
exports.Search = Search;
exports.Legend = Legend;
exports.Loader = Loader;
exports.Toaster = Toaster;
exports.TimeRangeInput = TimeRangeInput;
exports.InfoCallout = InfoCallout;
exports.TimeInput = TimeInput;
exports.brightTheme = index;
exports.defaultTheme = defaultTheme;
exports.internalTheme = index$1;
exports.ThemeProvider = ThemeProvider;



//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/react-components/dist/bundle.js
// module id = 590
// module chunks = 4